import React, { useEffect, useRef,useContext, useState } from 'react';
import { loadModules } from 'esri-loader';
import EditIcon from '@material-ui/icons/Edit';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import Button from '@material-ui/core/Button';
import MyLocationIcon from '@material-ui/icons/MyLocation';
import HomeIcon from '@material-ui/icons/Home';
import { Box, CircularProgress } from '@material-ui/core';
import Collapse from '@material-ui/core/Collapse';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Cookies from 'js-cookie';
import {isLogin, setCookie, clearCookie, getPrivileges } from '../../functions/Auth';
import MidBlock from '../../components_v2/DataFilter/MidBlock';
import Intersection from '../../components_v2/DataFilter/Intersection';
import ExportData from '../../components_v2/DataFilter/ExportData';
import API_PATH from "../../constants/config.json";
import SearchResults from '../../components_v2/DataFilter/SearchResults';
import { NavLink, useHistory } from 'react-router-dom';
import ImportPanel from './ImportData/ImportPanel';
import ImportList from './ImportData/ImportList';
import DICTIONARY_TO_SEARCH from "../../constants/dictionary.json";
import ExternalLayers from './ExternalLayers';
import DataPointLayers from './DataPointLayers';
import PopupTemplate from '../DataFilter/PopupTemplate';
import { Close } from '@material-ui/icons';
import ExportExternalLayers from './ExportExternalLayers';
import '../../scss/components/_externalLayers.scss';
import MapContext from '../../context/MapContext'
import LinearProgress from '@material-ui/core/LinearProgress';
import DataIconsTooltip from '../StationDetails/Tooltip/DataIconsTooltip';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import Footer from '../Footer/Footer';

//stations details
import {getIntersentionRecentYear,getIntersectionDatePeakData,getIntersectionTurningMovement,getIntersectionTruckPercentage,getIntersectionPedestrianMovement,getIntersectionBicycleMovement, getIntersectionBicycleCrosswalkMovement, getIntersectionLaneGeometryMovement} from '../../components_v2/Information/IntersectionGetData';
import {getMidblockStationRecentYear,getMidblockSummaryData,getMidblockADTeChart} from '../../components_v2/Information/MidblockGetData';
import ImportTable from './ImportData/ImportTable';
import ExportStations from './ExportStations'
import ExportDataDetails from '../StationDetails/ExportDataDetails';
import StationDetails from '../DataManagement/StationDetails';           
import DataManagement from '../DataManagement/DataManagement';
//import Headerv2 from '../../components_v2/Headers/Header';          
import HelpDisk from '../Information/HelpDisk';  
import ToggleScenarios from './ToggleScenarios';
import jwt_decode from "jwt-decode";  

let flag=false;
const axios = require('axios');
const queryString = require('query-string');
const API_URL = process.env.REACT_APP_BASE_URL;
let geolayer;
let sp = true; // search panel status
let geojsonLayer = null;
let changeBasemap = false;
let importDataMapPoint = false;
let myIndexValue = null;
let map;
let homeButton;
let sidebarWidth = '300px';
let cLayers = [];
let featureLayerView;
let featurExternalLayerView = [];
let mainGeomety;
let filterLayerView = null;
let polygonLayer = null;
let polygonToggle = false;
let polygonGeom = null;
let previousResultForPolygon = null;
let activeImportFiles = false;
let activeExportFiles = false;
let filterToggle = false;
let filterGlobal = false;
let storageFileIds = null; // null = no filter active; [] = active, no matches; [id,...] = matching station ids
let polygonGraphic = null;
let polygonExtent = null;
let view = null;
let previousResult = null;
let filterResult = [];
let stationLocationSelection = null;
let myFilterMV = null;

const AWS = require('aws-sdk');

let myGeoLayer;
let pointGraphic;
let point;
let stationData;
let stationIDData = [];
let basemapView;
let searchedList = [];
let layerViewUpdated = false;
let _intersectionChecked
let _midblockChecked
let _popupTemplateChecked = false;
var tuningMap = new Map()
var bykeMap = new Map()
var pedMap = new Map()
let _searchTxt = "";
let int_signal = [];
let int_stop = [];
let int_roundabout = [];
let int_unkown = [];

var classMap = new Map()
var speedMap = new Map()
var volumeMap = new Map()
var globarsearchResultv2=[]

let toggleScenariosTmp = false;
let midIntFiltersIsHidden;
let midAndIntDateFilters;
let iconMarkerBasedOnLaneGeometryLayer = false;
let iconMarkerBasedOnCapacityLayer = false;
let iconMarkerCapacitySelected = '';
let suggestStart = false;

// markers 
let symbolInt = {
  type: "picture-marker",  // autocasts as new PictureMarkerSymbol()
  url: require("../../assets/icons/map_pin_int.png"),
  width: "40px",
  height: "40px",
  yoffset: "20px"
};
let symbolMid = {
  type: "picture-marker",  // autocasts as new PictureMarkerSymbol()
  url: require("../../assets/icons/map_pin_mid.png"),
  width: "40px",
  height: "40px",
  yoffset: "20px"
};
let symbolInt_shared = {
  type: "picture-marker",  // autocasts as new PictureMarkerSymbol()
  url: require("../../assets/icons/map_pin_int_shared.png"),
  width: "40px",
  height: "40px",
  yoffset: "20px"
};
let symbolMid_shared = {
  type: "picture-marker",  // autocasts as new PictureMarkerSymbol()
  url: require("../../assets/icons/map_pin_mid_shared.png"),
  width: "40px",
  height: "40px",
  yoffset: "20px"
};
const otherSym = {
  type: "simple-marker",  // autocasts as new SimpleMarkerSymbol()
  size: 6,
  color: "black",
  outline: {  // autocasts as new SimpleLineSymbol()
    width: 0.5,
    color: "white"
  }
};
const hiddenSym = {
  type: "simple-marker",  // autocasts as new SimpleMarkerSymbol()
  size: 0,
  color: "black",              
  outline: {  // autocasts as new SimpleLineSymbol()
    width: 0,
    color: "white"
  }
};
let symbolIntRed = {
  type: "picture-marker",  // autocasts as new PictureMarkerSymbol()
  url: require("../../assets/icons/map/map_pin_intRed.png"),
  width: "64px",
  height: "64px",
  yoffset: "30px"
};
let symbolMidRed = {
  type: "picture-marker",  // autocasts as new PictureMarkerSymbol()
  url: require("../../assets/icons/map/map_pin_midRed.png"),
  width: "64px",
  height: "64px",
  yoffset: "30px"
};
let symbolInt_sharedRed = {
  type: "picture-marker",  // autocasts as new PictureMarkerSymbol()
  url: require("../../assets/icons/map/map_pin_int_sharedRed.png"),
  width: "64px",
  height: "64px",
  yoffset: "30px"
};
let symbolMid_sharedRed = {
  type: "picture-marker",  // autocasts as new PictureMarkerSymbol()
  url: require("../../assets/icons/map/map_pin_mid_sharedRed.png"),
  width: "64px",
  height: "64px",
  yoffset: "30px"
};
let intSignalSym = {
  type: "picture-marker",  // autocasts as new PictureMarkerSymbol()
  url: require("../../assets/icons/map_pin_signal.svg"),
  width: "40px",
  height: "40px",
  yoffset: "20px"
};
let intStopSym = {
  type: "picture-marker",  // autocasts as new PictureMarkerSymbol()
  url: require("../../assets/icons/map_pin_stop.svg"),
  width: "40px",
  height: "40px",
  yoffset: "20px"
};
let intunknownSym = {
  type: "picture-marker",  // autocasts as new PictureMarkerSymbol()
  url: require("../../assets/icons/map_pin_unknown.svg"),
  width: "40px",
  height: "40px",
  yoffset: "20px"
};
let intRoundaboutSym = {
  type: "picture-marker",  // autocasts as new PictureMarkerSymbol()
  url: require("../../assets/icons/map_pin_roundabout.svg"),
  width: "40px",
  height: "40px",
  yoffset: "20px"
};


var tuningMap = new Map()
var bykeMap = new Map()
var pedMap = new Map()

var classMap = new Map()
var speedMap = new Map()
var volumeMap = new Map()
var globarsearchResultv2=[]


//Start MapView component code ...
const MapView = (props) => {
  let chekpath = false;
  if (window.location.pathname == "/" || window.location.pathname == "/UsersDashboard") {
    chekpath = false;
  }
  const [popupTitle, setPopupTitle] = React.useState("");
  const [popupContent, setPopupContent] = React.useState([]);
  const [popuptemplateChecked, setPopuptemplateChecked] = React.useState(false);
  const [checked, setChecked] = React.useState(chekpath);
  const mapRef = useRef();
  const searchRef = useRef();
  const [basemap, setbasemap] = React.useState('streets-navigation-vector');
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [home, setHome] = React.useState(null);
  const [zoom, setZoom] = React.useState(null);
  const [locate, setLocate] = React.useState(null);
  const [measurement, setMeasurement] = React.useState(null);
  const [errPopUp, setErrPopUp] = React.useState(false);
  const [mapLoadStatus, setMapLoadStatus] = React.useState(0);
  const [showAllStations, setShowAllStations] = React.useState(null);
  const [mapView, setMapView] = React.useState(null);
  const [midblockChecked, setMidblockChecked] = React.useState(false);
  const [intersectionChecked, setIntersectionChecked] = React.useState(false);
  const [panelStationData, setPanelStationData] = React.useState();
  const [geoJSONNF, setGeoJSONNF] = React.useState(false);
  const [searchChecked, setSearchChecked] = React.useState(false);  
  const [searchResult, setSearchResult] = React.useState([]);
  const [searchParam, setSearchParam] = React.useState('');
  const [selectedStation, setSelectedStation] = React.useState();
  const [selectedStationType, setSelectedStationType] = React.useState();
  const [tempView, setTempView] = React.useState(null);
  const [tempViewPinState, setTempViewPinState] = React.useState(null);
  const [tempGeoLayer, setTempGeoLayer] = React.useState(null);
  const [myView, setMyView] = React.useState(null);
  const [loaderOff, setLoaderOff] = React.useState(false);
  const [loadSource, setLoadSource] = React.useState(true);
  const [checkedImport, setCheckedImport] = React.useState(false);
  const [showFileList, setShowFileList] = React.useState('none');
  const [details, setDetails] = React.useState([]);
  const [showimportData, setShowimportData] = React.useState('none');
  const [loaderShow, setLoaderShow] = React.useState('block');
  const [mapLocation, setMapLocation] = React.useState([]);
  const [stationDetails, setStationDetails] = React.useState([]);
  const [importResponceValue, setImportResponceValue] = React.useState(0);
  const [showUseStationData, setShowUseStationData] = React.useState('none');
  const [fileCountData, setFileCountData] = React.useState('block');
  const [showImportButton, setShowImportButton] = React.useState('block');
  const [geoLayer, setGeoLayer] = React.useState();
  const [geoLayerData, setGeoLayerData] = React.useState();
  const [allStationList, setAllStationList] = React.useState([]);
  const [exportChecked, setExportChecked] = React.useState('none');
  const [exportCheckedDetails, setExportCheckedDetails] = React.useState('none');
  const [getSearchWidget, setSearchWidget] = React.useState(null);
  const [searchedStation, setSearchedStation] = React.useState(null);
  const [idIndex, setIdIndex] = React.useState(null);
  const [useStationId, setUseStationId] = React.useState();
  const [useStationLocation, setUseStationLocation] = React.useState();
  const [useStationLat, setUseStationLat] = React.useState();
  const [useStationLong, SetUseStationLong] = React.useState();
  const [useStationStatus, SetUseStationStatus] = React.useState();
  const [multipleStationId, setMutipleStationId] = React.useState([]);
  const [singleMidblockStationId, setSingleMidblockStationId] = React.useState([]);
  const [singleIntersectionStationId, setSingleIntersectionStationId] = React.useState([]);
  const [zoomLevel, setZoomLevel] = React.useState(null);

  const [getFileStorage, setFileStorage] = React.useState(0);
  const [getCloudStorage, setCloudStorage] = React.useState(0);

  const [getMapLayer, setMapLayer] = React.useState(true);

  const [polygonActive, setPolygonActive] = React.useState(false);
  const [polygonDrawn, setPolygonDrawn] = React.useState(false);
  const [importStationId, setImportStationId] = React.useState(false);
  const [showSearchUseStationData, setSearchShowUseStationData] = React.useState('none');

  // external layers variables
  let layersFlag = sessionStorage.getItem('layersFlag');
  const [showExternalLayers, setShowExternalLayers] = React.useState(false);
  const [showDataPointLayers, setShowDataPointLayers] = React.useState(true);
  const [addingExternalLayer, setAddingExternalLayer] = React.useState(false);
  const [layerName, setLayerName] = React.useState("");
  const [layerUrl, setLayerUrl] = React.useState("");
  const [symbolColor, setSymbolColor] = React.useState("");
  const [customLayers, setCustomLayers] = React.useState([]);
  let [myCustomLayers, setMyCustomLayers] = React.useState([]);
  const [externalLayersToExport, setExternalLayersToExport] = React.useState([]);
  const [activeExtLayers, setActiveExtLayers] = React.useState(0);
  const [activeDataPointLayers, setActiveDataPointLayers] = React.useState(0);

  //v2
  const [searchResultv2, setSearchResultv2] = React.useState([]);
  
  const [showSearchWidgetResult, setShowSearchWidgetResult] = React.useState(false);
  
  

  const prevLoginRef = React.useRef();
  const prevLogin = prevLoginRef.current;

  //panel details    
  const [detailsPanel, setDetailsPanel] = React.useState(false);
  const [hasData, setHasData] = React.useState(false);

  const [detailsPanelIntersection, setDetailsPanelIntersection] = React.useState({});
  const [detailsPanelMidblock, setDetailsPanelMidblock] = React.useState({});
  const [loadingDetails, setLoadingDetails] = React.useState(false);

  const [importFilesListChecked, setImportFilesListChecked] = useState(false);
  const [showImportTable, setShowImportTable] = useState(false);
  const [activeStationIDSel, setActiveStationIDSel] = useState(null);

  const [streetViewMode, setStreetViewMode] = useState(false);

  const [sharedStation,setSharedStation] = useState(false);
  const [sharedAgencyName,setSharedAgencyName] = useState(false);
  const [showStationDetails, setShowStationDetails] = React.useState(false);
  const [needToReload, setNeedToReload] = React.useState(false);

  ////Data managment
  const [openDataManagement, setOpenDataManagement] = useState(false);
  const [toggleScenariosLayer, setToggleScenariosLayer] = useState(false);
  const [toggleMarkerBasedOnCapacityLayer, setToggleMarkerBasedOnCapacityLayer] = useState(false);
  const [toggleMarkerCapacitySelected, setToggleMarkerCapacitySelected] = useState('AM');
  const [toggleMarkerBasedOnLaneGeometryLayer, setToggleMarkerBasedOnLaneGeometryLayer] = useState(false);
  const [viewComp, setViewComp] = useState();
  const handleOpenDataManager = () => {   
    setOpenDataManagement(true);
  }
  /////////////////////
 // let view = null;
  let history = useHistory();
  const {filterisactive,updateFilterisactive,setFilter,filter,updateMainFilter,clearMainFilter,agenciesEnabled,setSearchEnabled,addNewStation,getUpdateStationDetails,midAndIntFiltersIsHidden,setHiddenMidAndIntFilters,midAndIntAndDateFilters,suggestStartActive,setActiveSuggestStart}=useContext(MapContext)
  useEffect(() => { 
    
    globarsearchResultv2=searchResultv2
        
  }, [searchResultv2])
  useEffect(() => { 
    if(agenciesEnabled.name){
      enabledStationsAgency(agenciesEnabled);   
    }    
  }, [agenciesEnabled])
  
  useEffect(() => { 
    
    setMidblockChecked(midblockChecked);
    _midblockChecked=midblockChecked

    
   }, [midblockChecked])
  useEffect(() => { 
    
    setIntersectionChecked(intersectionChecked);
    _intersectionChecked=intersectionChecked
    

  }, [intersectionChecked])

  useEffect(()=>{
    if (filterisactive){
      returnMainLIstPanel();
      if (midAndIntFiltersIsHidden && midAndIntAndDateFilters) {
        filter.turn = true;
        filter.pedestrian = true;
        filter.bicycle = true;
      }
      filterGlobal=filter
      doCustomFilter(filterisactive,filter)
      if (Object.values(filter.intersection_type).filter(item => item === true).length > 0)
        changeDefaultRender();
      else 
        setDefaultRender();
      // if (getSearchWidget) getSearchWidget.clear();
    } else {
      filterGlobal=filter
      setDefaultRender();
      doCustomFilter(filterisactive,filter);
    }
    setTimeout(() => {
      if(!filter.class && !filter.volume && !filter.speed && !filter.turn && !filter.pedestrian && !filter.bicycle && filter.endDate=="" && filter.startDate=="" && !Object.values(filter.intersection_type).filter(item => item === true).length > 0){
        updateFilterisactive(false)
        //
      }
    }, 1500);
  },[filter])

  useEffect(() => {
    const clearFilter = () => {
      filter.volume = false;
      filter.class = false;
      filter.speed = false;
      filter.turn = false;
      filter.pedestrian = false;
      filter.bicycle = false;
    }

    if (midAndIntFiltersIsHidden) {
      midIntFiltersIsHidden = midAndIntFiltersIsHidden;
      /* if (filterisactive) {
        clearFilter();
        if (midAndIntAndDateFilters) {
          filter.turn = true;
          filter.pedestrian = true;
          filter.bicycle = true;
        } else {
          updateFilterisactive(false);
        }
      } */
      filterGlobal=filter
      //doCustomFilter(filterisactive, filter);
      if (getSearchWidget) getSearchWidget.clear();
    } else {
      midIntFiltersIsHidden = midAndIntFiltersIsHidden;
      /* if (filterisactive)
        clearFilter(); */
      filterGlobal=filter
      //doCustomFilter(filterisactive, filter);
      if (getSearchWidget) getSearchWidget.clear();
    }
  }, [midAndIntFiltersIsHidden]);

  useEffect(() => {
    midAndIntDateFilters = midAndIntAndDateFilters;
    if (!midAndIntAndDateFilters) {
      filter.startDate = "";
      filter.endDate = "";
      filterGlobal.startDate = "";
      filterGlobal.endDate = "";
      doCustomFilter(filterisactive, filter);
    }
  }, [midAndIntAndDateFilters]);

  useEffect(()=>{
    filterToggle=filterisactive
  },[filterisactive])

  useEffect(() => {
    const activeTerms = (filter.storageFileTerms || []).filter(t => t.trim() !== '');
    const fromDate = filter.storageFileFromDate || null;
    const toDate = filter.storageFileToDate || null;

    if (activeTerms.length === 0 && !fromDate && !toDate) {
      storageFileIds = null;
      doCustomFilter(filterToggle, filterGlobal);
      return;
    }
    const headers = Cookies.get('payload')
      ? { agencyid: sessionStorage.getItem('agency_id'), payload: Cookies.get('payload') }
      : { agencyid: sessionStorage.getItem('agency_id') };
    axios({
      method: 'post',
      data: {
        terms: activeTerms,
        operator: filter.storageFileOperator || 'OR',
        fromDate: fromDate ? fromDate.toISOString() : null,
        toDate: toDate ? toDate.toISOString() : null,
      },
      headers: headers,
      url: API_URL + API_PATH.filterStationByStorageFile,
    })
    .then(response => {
      const raw = response.data && response.data.data ? response.data.data : '';
      storageFileIds = raw ? raw.split(',').map(Number).filter(Boolean) : [];
      doCustomFilter(filterToggle, filterGlobal);
    })
    .catch(err => {
      console.error('Storage file filter error:', err);
      storageFileIds = null;
      doCustomFilter(filterToggle, filterGlobal);
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter.storageFileTerms, filter.storageFileOperator, filter.storageFileFromDate, filter.storageFileToDate]);

  useEffect(() => {
    addedNewStation(addNewStation);
   }, [addNewStation])

   useEffect(() => {     
    editStationDetails(getUpdateStationDetails);
   }, [getUpdateStationDetails])

  useEffect(
    () => {
   
      // Home click resets map code starts
      if (props.clicked && props.clicked.clicked) {        
        if (tempView) {
          tempView.graphics.removeAll();
          tempViewPinState.graphics.removeAll();
          // tempView.zoom = 14;
        }    
        if (tempViewPinState) {
          tempViewPinState.graphics.removeAll();
          
        }       
        setSearchChecked(false);
        sp = true;
        setMidblockChecked(false);
        setPopuptemplateChecked(false);
        _popupTemplateChecked = false;
        setIntersectionChecked(false);
        if (geolayer && mapView) {
          mapView.remove(geolayer);
        }
        if (home) home.go();
        if (getSearchWidget) getSearchWidget.clear();
        setTimeout(() => {
          setChecked(false);
          setMapLayer(true);
        }, 150);
        props.clicked.clicked = false;
        if (geojsonLayer) {
          geojsonLayer.visible = true;
        }
      }
      // Home click resets map code ends

      prevLoginRef.current = props.newLogin;
      if (props.newLogin && props.newLogin !== prevLogin) { //show login success message
        setErrPopUp(true);
        sp = true;
      }
      const parsed = queryString.parse(window.location.search);
      if (parsed && parsed.import == 1 && getPrivileges().length !== 0) { // open import file drag and drop modal
        if (parsed.station) {
          setImportStationId(parsed.station);
          // setMidblockChecked(false);
          // setIntersectionChecked(false);
        } 
        else {
          // setMidblockChecked(false);
          // setIntersectionChecked(false);
          setImportStationId();
          // if (tempView) {
          //   tempView.graphics.removeAll();
          //   tempView.zoom = 14;
          // }
          // if (geojsonLayer) {
          //   geojsonLayer.visible = false;
          // }
          // setSearchChecked(false);
          sp = true;
        }
        setCheckedImport(true);
        // setImportFilesListChecked(true);
        // getAllStationList();
      } else {
        setCheckedImport(false);
      }
      if (mapLoadStatus === 0) {
        changeBasemap = false;
        geojsonLayer = null;
        if (getPrivileges().length !== 0) {
          getStationId();
        }
          callMap();
      
      }
    }, [basemap, props.newLogin, showAllStations, window.location.search, props.clicked]
  );


  /** External layers functions **/
  const handleShowLayersContainer = () => {
    setShowDataPointLayers(false);
    setShowExternalLayers(!showExternalLayers);
  }
  const handleShowDataPointLayersContainer = () => {
    setShowExternalLayers(false);
    setShowDataPointLayers(!showDataPointLayers);
  }
  const handleAddLayer = () => {
    setAddingExternalLayer(!addingExternalLayer);
  }

  const getExternalLayers = async() => {
    try {
      axios({
          method: 'post',
          headers: {
              'payload': Cookies.get('payload'),
              'agencyid': sessionStorage.getItem('agency_id')
          },
          url: API_URL + API_PATH.getLayers,
      })
      .then(async function (response) {
          if (response.status && response.status == '200') {
              let data = response.data.data;
              let tmpExternal = [];
              await loadModules(["esri/layers/FeatureLayer"], { css: true })
              .then(async ([FeatureLayer]) => {
                data.forEach( function(layer, ind) {

                  const template=layer.json_template

                  let tmpLayer = new FeatureLayer({
                    url: layer.url,
                    popupTemplate:template,
                    layer_type_a:"external"
                  });
                  let icon = null;
                  if(layer.json_style) {
                    tmpLayer.renderer = layer.json_style;
                    if(layer.json_style.symbol) {
                      let sym = layer.json_style.symbol;
                      icon = gettingLayerIcon(sym);
                    }
                  }
                  map.add(tmpLayer, ind);
                  let visibleV = layer.visibility;
                  // gettins external layers from cookies just for logged users
                  // if(Cookies.get('payload') && sessionStorage.getItem('externalLayers') && sessionStorage.getItem('externalLayers') !== ""){
                  //   let cookiesLayers = JSON.parse(sessionStorage.getItem('externalLayers'));
                  //   cookiesLayers.forEach(function(cookieL){
                  //     if(cookieL.layerName === layer.name){
                  //       visibleV = cookieL.visible;
                  //       tmpLayer.visible = cookieL.visible;
                  //     }
                  //   })
                  // } else {
                    tmpLayer.visible = visibleV;
                  // }
                  tmpExternal.splice(layer.order,0,{layerName: layer.name, layerUrl: layer.url, layerType: layer.type, layerObj: tmpLayer, visible: visibleV, order: layer.order, icon });
                });
                getVisibleLayers(tmpExternal);
              });
              setCustomLayers(tmpExternal)
              cLayers = tmpExternal;
              map.add(geojsonLayer);
              polygonValidation();
          } 
      })
    } catch (error) {
        console.error(error);
    }
  }
  
  const getlistOfStationFiltered=(filter,start_datev,end_datev)=>{
    
    var startTime = performance.now()
    //turningv,bykev,pedv,classv,speedv,volumev
   //console.log("filter",filter)
    let listId=""
    let _t=false
    let _b=false
    let _p=false

    let _c=false
    let _s=false
    let _v=false

    let _int_signal=false;
    let _int_stop=false;
    let _int_roundabout=false;
    let _int_unkown=false;
    
    //define default dates
    let _start_d="1900-01-01"
    let _end_d=getCurrentDate()

    //set dates from filter
    if(start_datev!="" && end_datev!=""){
       _start_d=start_datev
       _end_d=end_datev
    }
    let study_filter_is_active=false

    //review if if filter type is active
    for(var key in filter){
      if(filter[key]==true){
        study_filter_is_active=true;
      }
    }

    if (Object.values(filter.intersection_type).filter(item => item === true).length > 0){
      study_filter_is_active=true;
    }
    
    let arrayMain=[]
 
   
    //nofilter selected selected
    if(!study_filter_is_active && start_datev=="" && end_datev==""){
    
      return "nofilter"; 
    }
    _start_d = new Date(_start_d);
    _end_d = new Date(_end_d);
    //if only dates filter is selected
    if(start_datev!="" && end_datev!="" && (_start_d<_end_d)){
      _start_d = new Date(_start_d);
      _end_d = new Date(_end_d);
      if(_start_d<_end_d){

      }

      _t=false; _b=false; _p=false; _c=false; _s=false;  _v=false
      //_int_signal = false; _int_stop = false; _int_roundabout = false; _int_unkown = false;
      if(!study_filter_is_active){
     
        _t=true; _b=true; _p=true; _c=true; _s=true;  _v=true
        //_int_signal = true; _int_stop = true; _int_roundabout = true; _int_unkown = true;
        
      }else{
     
        _t=filter.turn;  _b=filter.bicycle; _p=filter.pedestrian;
        _c=filter.class; _s=filter.speed; _v=filter.volume;
        _int_signal = filter.intersection_type.signal;
        _int_stop = filter.intersection_type.stop;
        _int_roundabout = filter.intersection_type.roundabout;
        _int_unkown = filter.intersection_type.unknown;

      }
     

       
       // arrayMain=[]
        if(_v){
          arrayMain=loopMapByDAte(volumeMap,_start_d,_end_d,arrayMain); 
        
        }
        if(_c){
          arrayMain=loopMapByDAte(classMap,_start_d,_end_d,arrayMain);
                  
        }
        if(_s){
          arrayMain=loopMapByDAte(speedMap,_start_d,_end_d,arrayMain);
                 
        }
        if (_int_signal || _int_stop || _int_roundabout || _int_unkown) {
            
            let finalByDate = [];


              if (!_t && !_b && !_p){

                const turningByDate = loopMapByDAte(tuningMap, _start_d, _end_d, []);
                const bykeByDate = loopMapByDAte(bykeMap, _start_d, _end_d, []);
                const pedByDate = loopMapByDAte(pedMap, _start_d, _end_d, []);

                finalByDate = [...turningByDate.values(), ...bykeByDate.values(), ...pedByDate.values()];

              } else {
                if (_t){
                  const turningByDate = loopMapByDAte(tuningMap, _start_d, _end_d, []);
                  finalByDate = finalByDate.concat(...turningByDate.values());
                }
  
                if (_b){
                  const bykeByDate = loopMapByDAte(bykeMap, _start_d, _end_d, []);
                  finalByDate = finalByDate.concat(...bykeByDate.values());
                }
  
                if (_p){
                  const pedByDate = loopMapByDAte(pedMap, _start_d, _end_d, []);
                  finalByDate = finalByDate.concat(...pedByDate.values());
                }
              }


              if (_int_signal) {
                const finalBySignal = finalByDate.filter(item => int_signal.includes(item));
                arrayMain = arrayMain.concat(...finalBySignal.values())
              }

              if (_int_stop) {
                const finalByStop = finalByDate.filter(item => int_stop.includes(item));
                arrayMain = arrayMain.concat(...finalByStop.values())
              }

              if (_int_roundabout) {
                const finalByRoundabout = finalByDate.filter(item => int_roundabout.includes(item));
                arrayMain = arrayMain.concat(...finalByRoundabout.values())
              }

              if (_int_unkown) {
                const finalByUnkown = finalByDate.filter(item => int_unkown.includes(item));
                arrayMain = arrayMain.concat(...finalByUnkown.values())
              }         
        } else {
          if(_p){
            arrayMain=loopMapByDAte(pedMap,_start_d,_end_d,arrayMain);
                    
          }
          if(_t){
            arrayMain=loopMapByDAte(tuningMap,_start_d,_end_d,arrayMain);
                   
          }
          if(_b){
            arrayMain=loopMapByDAte(bykeMap,_start_d,_end_d,arrayMain);
          }
        }

    
    }else if( (start_datev=="" || end_datev=="") && study_filter_is_active){
      //only type filter is selected
      //get all data from  hasmaps
     
      _t=filter.turn;  _b=filter.bicycle; _p=filter.pedestrian;
      _c=filter.class; _s=filter.speed; _v=filter.volume;
      _int_signal = filter.intersection_type.signal;
      _int_stop = filter.intersection_type.stop;
      _int_roundabout = filter.intersection_type.roundabout;
      _int_unkown = filter.intersection_type.unknown;

      arrayMain=[]

      if(_v){
        arrayMain = arrayMain.concat(...volumeMap.values())
      }
      if(_c){
        arrayMain = arrayMain.concat(...classMap.values())
      }
      if(_s){
        arrayMain = arrayMain.concat(...speedMap.values())
      }
      if (_int_signal || _int_stop || _int_roundabout || _int_unkown) {
        if (_t || _b || _p) {
          //let turningTemp = [].concat(...tuningMap.values());
          let intersectionTemp = [];
          if (_t) {
            intersectionTemp = intersectionTemp.concat(...tuningMap.values());
          }
          if (_b) {
            intersectionTemp = intersectionTemp.concat(...bykeMap.values());
          }
          if (_p) {
            intersectionTemp = intersectionTemp.concat(...pedMap.values());
          }

          if (_int_signal) {
            let turningWithSignal = intersectionTemp.filter(item => int_signal.includes(item));
            arrayMain = arrayMain.concat(...turningWithSignal.values())
          }
          if (_int_stop) {
            let turningWithStop = intersectionTemp.filter(item => int_stop.includes(item));
            arrayMain = arrayMain.concat(...turningWithStop.values())
          }
          if (_int_roundabout) {
            let turningWithRoundabout = intersectionTemp.filter(item => int_roundabout.includes(item));
            arrayMain = arrayMain.concat(...turningWithRoundabout.values())
          }
          if (_int_unkown) {
            let turningWithunknown = intersectionTemp.filter(item => int_unkown.includes(item));
            arrayMain = arrayMain.concat(...turningWithunknown.values())
          }

        } else {
          if (_int_signal) {
            arrayMain = arrayMain.concat(...int_signal.values())
          }
          if (_int_stop) {
            arrayMain = arrayMain.concat(...int_stop.values())
          }
          if (_int_roundabout) {
            arrayMain = arrayMain.concat(...int_roundabout.values())
          }
          if (_int_unkown) {
            arrayMain = arrayMain.concat(...int_unkown.values())
          }
        }
      } else {
        if (_p) {
          arrayMain = arrayMain.concat(...pedMap.values())
        }
        if (_t) {
          arrayMain = arrayMain.concat(...tuningMap.values())
        }
        if (_b) {
          arrayMain = arrayMain.concat(...bykeMap.values())
        }
      }
      
    }
    
      var uniqueArr = [...new Set(arrayMain)]
    
      var endTime = performance.now()
      //console.log(`Performance time filter ${endTime - startTime} milliseconds`)

    return uniqueArr
  

  }
  const loopMapByDAte =(map,start_date,end_date,_main_array)=>{
    map.forEach(function(value,key){
      let _temp_date=new Date(key)
      if(_temp_date >= start_date && _temp_date < end_date ){
        _main_array=_main_array.concat(value);
      }
      
    })
    return _main_array;
  }

  const getCurrentDate=()=>{
    var d = new Date(),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;
    return [year, month, day].join('-');

  }
  const doCustomFilter = (filterValue,myfilter) => {
    try {
      if(geojsonLayer){
        const tmplayer = polygonLayer && polygonLayer.visible ? polygonLayer : geojsonLayer;
        loadModules(["esri/layers/FeatureLayer","esri/core/watchUtils","esri/tasks/support/Query"], { css: true })
            .then(async ([FeatureLayer,watchUtils,Query]) => {

              let query = gettingQueryWhere();

              query.orderByFields = ["client_station_id ASC"];
              view.whenLayerView(tmplayer).then(function (layerView) {
                // Update the pie chart after the user stops panning or zooming
                layerView.effect={
                  filter:{
                    where:query.where
                  },
                  excludedEffect:"grayscale(100%) opacity(0%)"
                }
                layerView.queryFeatures(query).then(function(results){
                  if(!isLogin()){
                    results.features.forEach(function(station,index){
                      if(station.attributes.is_shared){
                        results.features[index].attributes.visible = 0;
                      }
                    })
                  }
                  const {features} = results
                  previousResult = features;
                  setSearchChecked(true);
                  if(polygonToggle) {
                    selectFeatures(polygonGeom, view);
                  } else {
                    setShowSearchWidgetResult(false)
                    setSearchResult([])
                    setSearchResultv2(features)
                    setSearchChecked(true);
                  }
                })
              });
              
            });
      }
    } catch (error) {
      console.error(error);
    }

        

    ///////////////////////////
   
    
  }

  const enabledStationsAgency = (agency) =>{
    try {
      if(geojsonLayer){
        geojsonLayer.queryFeatures({}).then(function(results){          
          results.features.forEach(function(station,index){
            if(station.attributes.agency == agency.name){
              results.features[index].attributes.visible = (agency.visible)?1:0;                
              if(geojsonLayer){
                geojsonLayer.applyEdits( {
                  updateFeatures: [results.features[index]]
                }).then();
              }              
            }            
          });
          const {features} = results                         
          setSearchResultv2(features)
          setShowSearchWidgetResult(false)
          setSearchChecked(true); 
          if(geojsonLayer){
            geojsonLayer.refresh();      
          }          
          /**/
        })  
      }
    } catch (error) {
      console.error(error);
    }  
  }
  

  const gettingLayerIcon = (sym) => {
    let icon = null;
    let tmpcolor;
    switch (sym.type) {
      case 'picture-marker':
        icon = {type: 'image', url: sym.url}; 
        break;
      case 'simple-line':
        tmpcolor = sym.color ? `rgba(${sym.color.toString().replace('[','(').replace(']',')')})`: 'rgba(0,0,0,1)';
        let tmpwidth = sym.width ? sym.width : 1;
        icon = {type: 'line', color: tmpcolor, width: tmpwidth}; 
        break;
      case 'simple-marker':
        tmpcolor = sym.color ? `rgba(${sym.color.toString().replace('[','(').replace(']',')')})`: 'rgba(0,0,0,1)';
        icon = {type: 'marker', color: tmpcolor}; 
        break;
      case 'simple-fill':
        tmpcolor = sym.color ? `rgba(${sym.color.toString().replace('[','(').replace(']',')')})`: 'rgba(0,0,0,1)';
        let tmpoutline = sym.outline ? sym.outline : null;
        icon = {type: 'fill', color: tmpcolor, outline: tmpoutline}; 
        break;
      default:
        icon = {type: null}; 
    }
    return icon;
  }

  const polygonValidation = () => {
    if(Cookies.get('payload') && Cookies.get('polygonExtent')) {
      let extent = JSON.parse(Cookies.get('polygonExtent'));
      view.whenLayerView(geojsonLayer).then(function(layerView){
        layerView.watch("updating", function(val){
          if(!val && !layerViewUpdated){  // wait for the layer view to finish updating
            layerView.queryExtent().then(function(results){
              view.extent = extent;  // go to the extent of all the graphics in the layer view
            });
            layerViewUpdated = true;
            clearCookie('polygonExtent');
            polygonToggle = false;
          }
        });
      });
    }
  }

  const handleSaveLayer = (layer) => {
    loadModules(["esri/layers/FeatureLayer"], { css: true })
      .then(async ([FeatureLayer]) => {
        let tmpLayer = new FeatureLayer({
          url: layer.url
        });

        // if(layer.json_style) {
        //   tmpLayer.renderer = layer.json_style
        // }
        map.add(tmpLayer);
        let tmpobj = [...myCustomLayers];
        tmpobj.push(tmpLayer);
        setMyCustomLayers(tmpobj);
      });
  } 

  const handleLayerVisibility = (e, ind) => {
    let visible = e.target.checked;
    customLayers[ind].layerObj.visible = visible;
    let n = customLayers.map( (layer,ii) => {
      if(ii === ind)
        layer.visible = visible;
      return layer;
    })
    setCustomLayers(n);
    getVisibleLayers();
  }

  const getVisibleLayers = (custom=null) => {
    let customL = custom ? custom : customLayers;
    let cc = 0;
    customL.map( layer => {
      if(layer.visible)
        cc++;
    });
    setActiveExtLayers(cc);
    setActiveDataPointLayers(cc);
  }

  const clearAllExternalLayers = () => {
    let n = customLayers.map( (layer) => {
      layer.visible = false;
      layer.layerObj.visible = false;
      return layer;
    })
    setCustomLayers(n);
    setActiveExtLayers(0);
    setActiveDataPointLayers(0);
  }

  const handleReorderLayer = (tmp) => {
    tmp.forEach( layer=> {
      map.remove(layer);
    })
    tmp.forEach( layer=> {
      map.add(layer);
    })
  }
  /****/

  const loaderFunction = () => {
    setLoaderOff(true);
  }
  useEffect(() => {
    if(sessionStorage.getItem('mapURL') !== 'https://services6.arcgis.com/VFCL16jxpNYJvQhh/ArcGIS/rest/services/int_stations/FeatureServer'){
    }else{
      try {
        if(geoLayerData){
          
            loadModules(["esri/geometry/Extent"], { css: true })
            .then(async ([Extent]) => {
              var stations = [];
              geoLayerData.features.forEach((element,i) => {
                if(element.properties.agency_id.toString() === sessionStorage.getItem('agency_id').toString()){
                  stations.push(element)
                }
              });
              // Find the minimum and maximum coordinates
              if(stations.length > 0){
              let minLongitude = 0;
              let maxLongitude = 0;
              let minLatitude = 0;
              let maxLatitude = 0;
              for (let i = 0; i < stations.length - 1; i++) {
                let longitude = stations[i].geometry.coordinates[0];
                let latitude = stations[i].geometry.coordinates[1];
                let nextLongitude = stations[i+1].geometry.coordinates[0];
                let nextLatitude = stations[i+1].geometry.coordinates[1];

                if(Math.abs(longitude - nextLongitude) < 0.3){
                  if(minLongitude === 0){
                    minLongitude = longitude
                  }else{
                    minLongitude = Math.min(minLongitude, longitude);
                  }
                }
                if(Math.abs(longitude - nextLongitude) < 0.3){
                  if(maxLongitude === 0){
                    maxLongitude = longitude
                  }else{
                    maxLongitude = Math.max(maxLongitude, longitude);
                  }
                }
                if(Math.abs(latitude - nextLatitude) < 0.3){
                  if(minLatitude === 0){
                    minLatitude = latitude
                  }else{
                    minLatitude = Math.min(minLatitude, latitude);
                  }
                }
                if(Math.abs(latitude - nextLatitude) < 0.3){
                  if(maxLatitude === 0){
                    maxLatitude = latitude
                  }else{
                    maxLatitude = Math.max(maxLatitude, latitude);
                  }
                }
              }

  
              // Create a new extent object based on the min and max coordinates
              let modifiedExtent = new Extent({
                xmin: minLongitude,
                ymin: minLatitude,
                xmax: maxLongitude,
                ymax: maxLatitude,
                spatialReference: {
                  wkid: 4326 
                }
              });
              viewComp.goTo(modifiedExtent);
              viewComp.zoom = 4;
            }
          })
        }
        
      } catch (error) {
        console.error(error);
      }
    }
  }, [geoLayerData])
  //This method is use for mapview and handle all map event .... Start
  const callMap = (basemap = 'streets-navigation-vector') => {
    setMapLoadStatus(1);
    // lazy load the required ArcGIS API for JavaScript modules and CSS
    loadModules(["esri/Map", "esri/views/MapView", "esri/widgets/Locate", "esri/widgets/Home",
      "esri/widgets/Zoom", "esri/widgets/Search","esri/widgets/Search/SearchSource", "esri/widgets/Measurement",
      "esri/layers/FeatureLayer", "esri/Viewpoint", "esri/geometry/Point", "esri/Graphic",
      "esri/layers/GeoJSONLayer", "esri/widgets/Sketch/SketchViewModel", "esri/layers/GraphicsLayer","esri/tasks/support/Query",
      "esri/widgets/BasemapToggle","esri/core/watchUtils", "esri/Basemap","esri/geometry/Extent"], { css: true })
      .then(async ([ArcGISMap, MapView, Locate, Home, Zoom, Search,SearchSource, Measurement, FeatureLayer,
        Viewpoint, Point, Graphic, GeoJSONLayer, SketchViewModel, GraphicsLayer,Query,
        BasemapToggle,watchUtils,Basemap,Extent]) => {

        let _basemap = new Basemap({
          portalItem: {
            id: "86265e5a4bbb4187a59719cf134e0018"  // Imagery Hybrid
          }
        });
        
        let previusBaseMap = _basemap;

        map = new ArcGISMap({
          basemap: basemap,
          slider: false
        });

        view = new MapView({
          container: mapRef.current,
          map: map,
          //zoom: 4,
          ui: {
            components: ['home', 'locate'] // specify only the components you want
          },
          constraints: {
            minZoom: 2
          }
        });
        setViewComp(view)
        var basemapToggle = new BasemapToggle({
          view: view,  // The view that provides access to the map's "streets-vector" basemap
          nextBasemap: previusBaseMap,  // Allows for toggling to the "hybrid" basemap
          container: document.getElementById("basemapToggle")
        });

        basemapToggle.on('toggle', function(event){          
          sessionStorage.setItem('baseMapType',event.current.id);
          if(event.current.id == 'hybrid'){
            setStreetViewMode(true);            
          }else{
            setStreetViewMode(false);
          }
        });
  
        view.ui.add(basemapToggle);
        setMapView(map);

        
        let featureLayer = new FeatureLayer({
          url: sessionStorage.getItem('mapURL')
        });
        map.add(featureLayer); // adds feature layer to map view
        featureLayer.when(function () {
          view.goTo(featureLayer.fullExtent);
         /* let vp = new Viewpoint({
            targetGeometry: featureLayer.fullExtent
          });

          view.extent =  featureLayer.fullExtent;
        */
        });

        let locate = new Locate({
          view: view,
        });

        homeButton = new Home({
          view: view,
        });

        if (tempView && zoomLevel == true) {
          view.extent = tempView.extent;
        }
        

        let zoom = new Zoom({
          view: view,
        });

        view.on("mouse-wheel", function (event) {
          setZoomLevel(true);
        });

        basemapView = view;
        setTempView(view);
        setTempViewPinState(view);
        let sketchViewModel;
        let polygonGraphicsLayer = new GraphicsLayer();

        // add the select by polygon button the view
        // view.ui.add("select-by-polygon", "top-left");
        const selectButton = document.getElementById("select-by-polygon");
        // let polygonToggle = false;

        // click event for the button
        selectButton.addEventListener("click", function () {
          // clearUpSelection();
          if (polygonToggle == false) {
            polygonToggle = true;
            setShowExternalLayers(false);
            setShowDataPointLayers(false);
          } else {
            polygonToggle = false;
          }
          view.popup.close();
          // ready to draw a polygon
          setPolygonActive(polygonToggle);
          setExternalLayersToExport([]);
          // clear effect to selected layers
          clearFilterExternalLayers();
          /**/
          if (polygonToggle == true) {
            view.graphics.removeAll();
            document.getElementById("map_block").style.cursor = "crosshair";
            map.add(polygonGraphicsLayer);
            sketchViewModel.create("polygon");
          } else {
            document.getElementById("map_block").style.cursor = "default";
            map.remove(polygonGraphicsLayer);
            setPolygonActive(false);
            setPolygonDrawn(false);
            if(polygonGraphic) polygonGraphicsLayer.remove(polygonGraphic);
            setShowSearchWidgetResult(false);
            setSearchResult([]);
            setSearchResultv2(previousResult);
            setSearchChecked(true);
            geojsonLayer.visible = true;
            map.remove(polygonLayer);
            polygonLayer = null;
            doCustomFilter(filterToggle, filterGlobal);
          }
        });

        // create a new sketch view model set its layer
        sketchViewModel = new SketchViewModel({
          view: view,
          layer: polygonGraphicsLayer,
          polygonSymbol: {
            type: "simple-fill", // autocasts as new SimpleFillSymbol()
            color: [255,255,255,0.1],
            outline: {
              color: "#2563EB",
              width: 5
            }
          },
          activeFillSymbol: {
            type: "simple-fill", // autocasts as new SimpleFillSymbol()
            color: [255,255,255,0.5],
            style: '',
            outline: {
              color: "#2563EB",
              width: 5
            }
          },
          updateOnGraphicClick: false
        });

        sketchViewModel.on("create", function (event) {
          if (event.state === "complete") {
            // close external layer details
            setPopuptemplateChecked(false);
            _popupTemplateChecked = false;
            // this polygon will be used to query features that intersect it
            // setSearchParam('');
            // _searchTxt = "";
            polygonGraphic = event.graphic;
            polygonGeom = event.graphic.geometry;
            selectFeatures(event.graphic.geometry, view);
            setPolygonActive(true);
            setShowExternalLayers(false);
            setShowDataPointLayers(false);
            setPolygonDrawn(true);
            setSearchChecked(false);
            setMidblockChecked(false);
            setIntersectionChecked(false);
            setDetailsPanel(false);
          } else if ((event.state === "start" || event.state === "active") && polygonToggle == false) {
            sketchViewModel.cancel();
            polygonGraphicsLayer.remove(event.graphic);
          }
        });

        let searchWidget;
        if (getSearchWidget == null) { // initialize search widget

          searchWidget = new Search({ //arcGIS search API to filter data from geoJSON loaded for stations
            allPlaceholder: "Search",
            view: view,
            includeDefaultSources: false,
            locationEnabled: false,
            popupEnabled: false,
            autoSelect: false,
            minSuggestCharacters: 3
          });

          setSearchWidget(searchWidget);

          searchWidget.on("suggest-start", function (event) {
            suggestStart = true;
            returnMainLIstPanel();            
            setSelectedStation(null)
            setMapLayer(true);
            //geojsonLayer.visible = false;
            //setMidblockChecked(false);
            //setIntersectionChecked(false);
            //setChecked(false);
          })

          searchWidget.on("search-start", function (event) {
            setMapLayer(true);
            setMidblockChecked(false);
            setIntersectionChecked(false);
            setChecked(false);
          })

          searchWidget.on("search-complete", function (event) { 
            returnMainLIstPanel();
            setSearchEnabled(true)
            if (geolayer) {
              map.remove(geolayer);
              geolayer = null;
            }
            if (suggestStart){
              setActiveSuggestStart(true);
              updateFilterisactive(false);
            }
            if (event.searchTerm !== "") { // get search results
              // remove polygon
              if(polygonToggle) {
                document.getElementById("map_block").style.cursor = "default";
                map.remove(polygonGraphicsLayer);
                setPolygonActive(false);
                setPolygonDrawn(false);
                if(polygonGraphic) polygonGraphicsLayer.remove(polygonGraphic);
                setShowSearchWidgetResult(false);
                setSearchResult([]);
                setSearchResultv2(previousResult);
                setSearchChecked(true);
                geojsonLayer.visible = true;
                map.remove(polygonLayer);
                polygonLayer = null;
                polygonToggle = false;
              }
              ///
              setSearchParam(event.searchTerm);
              _searchTxt = event.searchTerm;
              //geojsonLayer.visible = true;
              sp = false;
              doCustomFilter(filterToggle, filterGlobal);
              setTimeout(() => {
                doCustomFilter(filterToggle, filterGlobal);
              }, 800);
              /*
              let searchDataArr = [];
              for (let i = 0; i < event.results.length; i++) {
                if (event.results[i].results.length > 0) {
                  event.results[i].results.map((value, index) => {
                    let tmpItem = {
                      station_id: value.feature.attributes.station_id,
                      client_station_id: value.feature.attributes.client_station_id,
                      location: value.feature.attributes.station_location,
                      station_location: value.feature.attributes.station_location,
                      station_type: value.feature.attributes.station_type,
                      latitude: value.feature.attributes.latitude,
                      longitude: value.feature.attributes.longitude,
                      class: '',
                      speed: '',
                      turning: '',
                      pedestrian: '',
                      bicycle: '',
                      volume: '',
                      checked: false,
                      is_shared : value.feature.attributes.is_shared,
                      visible : value.feature.attributes.visible,
                      turningyear :value.feature.attributes.turningyear,
                      pedestrianyear :value.feature.attributes.pedestrianyear,
                      bicycleyear :value.feature.attributes.bicycleyear,
                      volumeyear :value.feature.attributes.volumeyear,
                      classyear :value.feature.attributes.classyear,
                      speedyear :value.feature.attributes.speedyear,
                      haslane: value.feature.attributes.haslane,
                      capacityam: value.feature.attributes.capacityam,
                      capacitymid: value.feature.attributes.capacitymid,
                      capacitypm: value.feature.attributes.capacitypm
                    };
                    // push at the first position the selected search item
                    if(event.searchTerm.indexOf(value.name) >= 0) {
                      searchDataArr.unshift(tmpItem)
                    } else {
                      searchDataArr.push(tmpItem)
                    }
                  })
                }
              }
              searchDataArr = [...new Map(searchDataArr.map(item => [item.station_id, item])).values()];
              if (searchDataArr.length == 1) {
                setSelectedStationType(searchDataArr[0].station_type);
                setSelectedStation(searchDataArr[0].station_id);
                let plat = searchDataArr[0].latitude;
                let plong = searchDataArr[0].longitude;
                view.graphics.removeAll();
                var point = new Point(plong, plat);
                var pointSymbol = {
                  type: "simple-marker",
                  style: "circle",
                  color: "#00A75D",
                  size: 20,
                  outline: {
                    color: "#00A75D",
                    width: 0.5
                  }
                }
                if (searchDataArr[0].station_type==1){
                  pointSymbol=symbolMidRed;
                }else{
                  pointSymbol=symbolIntRed;
                }

                // Create a Graphic the Search widget can display
                var graphic = new Graphic({
                  geometry: point, symbol: pointSymbol,
                });
                view.graphics.add(graphic);
              }
              setZoomLevel(null);
              setSearchedStation(graphic);                            
              setShowSearchWidgetResult(true)
              searchedList = searchDataArr;
              setSearchChecked(true);
              setMutipleStationId([]);
              setSearchResult(searchDataArr);
              returnMainLIstPanel();
              */
              /*** Set cookies for search before login ***/
              /*
              if(!Cookies.get('payload')) {
                clearCookie('activeSearchFilter');
                clearCookie('activeSearchStation');
                sessionStorage.setItem('activeSearchResult', JSON.stringify(searchDataArr));
                setCookie('activeSearchText', event.searchTerm);
              }
              */
              /******/
            }
          });

          searchWidget.on("search-clear", async function (event) {
            returnMainLIstPanel();
            const clearFilter = () => {
              filter.turn = false;
              filter.pedestrian = false;
              filter.bicycle = false;
              filter.intersection_type.signal = false;
              filter.intersection_type.stop = false;
              filter.intersection_type.roundabout = false;
              filter.intersection_type.unknown = false;
              filterGlobal.turn = false;
              filterGlobal.pedestrian = false;
              filterGlobal.bicycle = false;
              filterGlobal.intersection_type.signal = false;
              filterGlobal.intersection_type.stop = false;
              filterGlobal.intersection_type.roundabout = false;
              filterGlobal.intersection_type.unknown = false;
              if (suggestStart){
                setActiveSuggestStart(true);
                updateFilterisactive(false);
              }
            }

            setSearchEnabled(false)                                        
            setSearchResultv2(previousResult);
            setShowSearchWidgetResult(false)
            setMidblockChecked(false);
            setIntersectionChecked(false);
            setSearchChecked(true);
            setSearchResult([]);
            setSearchParam("");
            _searchTxt = "";            
            filter.volume = false;
            filter.class = false;
            filter.speed = false;
            filterGlobal.volume = false;
            filterGlobal.class = false;
            filterGlobal.speed = false;
            if (filter.startDate === "")
            filter.startDate = "";
            if (filter.startDate === "")
              filter.endDate = "";
            if (filterGlobal.startDate === "")
              filterGlobal.startDate = "";
            if (filterGlobal.startDate === "")
              filterGlobal.endDate = "";
            if (filterToggle){
              if (midIntFiltersIsHidden){
                clearFilter();
                if (midAndIntDateFilters){
                  filter.turn = true;
                  filter.pedestrian = true;
                  filter.bicycle = true;
                  filterGlobal.turn = true;
                  filterGlobal.pedestrian = true;
                  filterGlobal.bicycle = true;
                }                
              } else{
                clearFilter();
              }
            } else{
                clearFilter();
            }  

            updateFilterisactive(!filterToggle)
            suggestStart = false;

            if (geolayer) {
              map.remove(geolayer);
              geolayer = null;
            }
            await doCustomFilter(filterToggle, filterGlobal);
            /*view.graphics.removeAll();
            // view.zoom = 14;
            // if(geojsonLayer) {
            //   geojsonLayer.visible = false;
            // }
            setSearchChecked(false);
            sp = true;*/
          });
        }
        else {

          getSearchWidget.on("suggest-start", function (event) {
            suggestStart = true;
            setSelectedStation(null);
            setMapLayer(true);
            geojsonLayer.visible = false;
            setMidblockChecked(false);
            setIntersectionChecked(false);
            setChecked(false);
          })

          getSearchWidget.on("search-start", function (event) {
            setMapLayer(true);
            setMidblockChecked(false);
            setIntersectionChecked(false);
            setChecked(false);
          })

          getSearchWidget.on("search-complete", function (event) {
            setSearchEnabled(true)
            if (geolayer) {
              map.remove(geolayer);
              geolayer = null;
            } else if (myGeoLayer) {
              map.remove(myGeoLayer);
            }
            setMutipleStationId([]);
            if (event.searchTerm !== "") {
              setSearchParam(event.searchTerm);
              _searchTxt = event.searchTerm;
              geojsonLayer.visible = true;
              sp = false;
              let searchDataArr = [];
              for (let i = 0; i < event.results.length; i++) {
                if (event.results[i].results.length > 0) {
                  event.results[i].results.map((value, index) => {
                    searchDataArr.push({
                      station_id: value.feature.attributes.station_id,
                      client_station_id: value.feature.attributes.client_station_id,
                      location: value.feature.attributes.station_location,
                      station_location: value.feature.attributes.station_location,
                      station_type: value.feature.attributes.station_type,
                      latitude: value.feature.attributes.latitude,
                      longitude: value.feature.attributes.longitude,
                      class: '',
                      speed: '',
                      turning: '',
                      pedestrian: '',
                      bicycle: '',
                      volume: '',
                      checked: false,
                      is_shared:value.feature.attributes.is_shared,
                      turningyear :value.feature.attributes.turningyear,
                      pedestrianyear :value.feature.attributes.pedestrianyear,
                      bicycleyear :value.feature.attributes.bicycleyear,
                      volumeyear :value.feature.attributes.volumeyear,
                      classyear :value.feature.attributes.classyear,
                      speedyear :value.feature.attributes.speedyear,
                      haslane: value.feature.attributes.haslane,
                      capacityam: value.feature.attributes.capacityam,
                      capacitymid: value.feature.attributes.capacitymid,
                      capacitypm: value.feature.attributes.capacitypm,
                      display_name: value.feature.attributes.display_name,
                      all_approach: value.feature.attributes.all_approach,
                    })
                  })
                }
              }
              searchDataArr = [...new Map(searchDataArr.map(item => [item.station_id, item])).values()];
              if (searchDataArr.length == 1) {
                setSelectedStationType(searchDataArr[0].station_type);
                setSelectedStation(searchDataArr[0].station_id);
                let plat = searchDataArr[0].latitude;
                let plong = searchDataArr[0].longitude;
                view.graphics.removeAll();
                var point = new Point(plong, plat);
                var pointSymbol = {
                  type: "simple-marker",
                  style: "circle",
                  color: "#00A75D",
                  size: 20,
                  outline: {
                    color: "#00A75D",
                    width: 0.5
                  }
                }
                
                if (searchDataArr[0].station_type==1){
                  pointSymbol=symbolMidRed;
                }else{
                  pointSymbol=symbolIntRed;
                }
                // Create a Graphic the Search widget can display
                var graphic = new Graphic({
                  geometry: point, symbol: pointSymbol,
                });
                view.graphics.add(graphic);
                view.goTo(graphic).then(function () {
                  view.zoom = view.zoom + 5;
                });
              }
              setSearchResult(searchDataArr);
              setShowSearchWidgetResult(true)
              searchedList = searchDataArr;
              setSearchChecked(true);
            }
          });

          getSearchWidget.on("search-clear", function (event) {
            setSearchEnabled(false)
            view.graphics.removeAll();
            // view.zoom = 14;
            tempGeoLayer.visible = false;
            setSearchChecked(false);
            sp = true;
          });
        }

        let measure = new Measurement({
          view: view,
        });

        if (changeBasemap == false) {
          let stationLayer = await getGeoJsonData();
          //create layer geogson
          if (stationLayer) { //create geoJSON layer for all stations of agency  
            const cluster = {
              type: "cluster",
              clusterRadius: "50px",
             /* popupTemplate: {
                content: "This cluster represents {cluster_count} stations."
              },*/
              clusterMinSize: "40px",
              clusterMaxSize: "40px",
              labelingInfo: [{
                deconflictionStrategy: "none",
                labelExpressionInfo: {
                  expression: "Text($feature.cluster_count, '#,###')"
                },
                symbol: {
                  type: "text",
                  color: "#fff",
                  font: {
                    weight: "bold",
                    family: "Noto Sans",
                    size: "18px"
                  }
                },
                labelPlacement: "center-center",
              }]
            }
            
            let citiesRenderer = getDefaultRender();                    
            const blob = new Blob([JSON.stringify(stationLayer)], { type: "application/json" });            
            const dataUrl = URL.createObjectURL(blob);
            geojsonLayer = new GeoJSONLayer({
              url: dataUrl,
              //featureReduction: cluster,
              outFields: ["station_id", "client_station_id", "station_location", "station_type", "latitude", "longitude",
              //"max_typemid","min_typemid","max_mid_year","min_mid_year","max_typeint","min_typeint","max_int_year","min_int_year",
              "visible","agency","key_value","is_shared",
              //"max_mid_year_filter","min_mid_year_filter","max_int_year_filter","min_int_year_filter",
              "turningyear", "pedestrianyear", "bicycleyear","volumeyear", "classyear", "speedyear",
              "filter_turningyear", "filter_pedestrianyear", "filter_bicycleyear","filter_volumeyear", "filter_classyear", "filter_speedyear",
              "haslane", "capacityam", "capacitymid", "capacitypm","display_name","all_approach", "lane_config_control_type"
              ],
              renderer: citiesRenderer
            });

            map.add(geojsonLayer);

            if (stationLayer.length !== 0) {
              geojsonLayer.when(function () {
                
                if (geojsonLayer) {
                  geojsonLayer.visible = true;
                }
              });
            }
            //button to test filter result
          /*  const btn_filter = document.getElementById("btnFilter");
            view.ui.add(btn_filter,"top-left")
            btn_filter.addEventListener("click", async()=>{
             
              //query.where = "station_type = 1";
              const lview =await  view.whenLayerView(geojsonLayer);
              await watchUtils.whenTrue(lview,"stationary");
              const query = lview.createQuery();
              query.geometry = view.extent;
              
              query.spatialRelationship = "within";
              query.where = "station_id > 0";
              const {features} =await lview.queryFeatures(query)
              console.log(features.length)
            
            })

            */
            view.when(  ()=> {
            
              //query.where = "station_type = 1";
              view.whenLayerView(geojsonLayer).then(function (layerView) {
                // Update the pie chart after the user stops panning or zooming
               // console.log("geojsonLayer: ",geojsonLayer)
                const querymain = layerView.createQuery();
                querymain.where = "station_id > 0";
                geojsonLayer.queryFeatures(querymain).then(function(results){ 
                  results.features.forEach(function(station,index){
                    //create object by date
                  
                    let _station_id=station.attributes.station_id;
                    let _type=station.attributes.station_type;
                    let _visible=station.attributes.visible;
                    let temp_obj={}
                   
                    if(station.attributes.station_type==2){
                      //do the process for intersection
                      //review counting, bycicle, pedestrian
                      let _turning=station.attributes.filter_turningyear.split(",")
                      let _byke=station.attributes.filter_bicycleyear.split(",")
                      let _ped=station.attributes.filter_pedestrianyear.split(",")

                      if (station.attributes.lane_config_control_type && station.attributes.lane_config_control_type !== null) {
                        if (station.attributes.lane_config_control_type.toLocaleLowerCase() === 'signal') {
                          int_signal.push(_station_id);
                        }
                        if (station.attributes.lane_config_control_type.toLocaleLowerCase() === 'stop') {
                          int_stop.push(_station_id);
                        }
                        if (station.attributes.lane_config_control_type.toLocaleLowerCase() === 'roundabout') {
                          int_roundabout.push(_station_id);
                        }                        
                      } else {
                        int_unkown.push(_station_id);
                      }
                    
                     
                      // create different hashmap
                      var starttime= performance.now()
                      _turning.forEach(function(value,index){
                        if(value.trim()!=""){              
                           var arr = []
                          if(!tuningMap.has(value.trim())){
                            arr = [_station_id];
                            tuningMap.set(value.trim(), arr); 
                          } else {
                          arr = tuningMap.get(value.trim());
                          arr.push(_station_id);
                          }
                        }

                        
                      })

                      _byke.forEach(function(value,index){
                        if(value.trim()!=""){
                          var arr = []
                          if(!bykeMap.has(value.trim())){
                            arr = [_station_id];
                            bykeMap.set(value.trim(), arr); 
                          } else {
                          arr = bykeMap.get(value.trim());
                          arr.push(_station_id);
                          }
                        }
                      })

                      _ped.forEach(function(value,index){
                        if(value.trim()!=""){
                          var arr = []
                          if(!pedMap.has(value.trim())){
                            arr = [_station_id];
                            pedMap.set(value.trim(), arr); 
                          } else {
                          arr = pedMap.get(value.trim());
                          arr.push(_station_id);
                          }
                        }
                      })
                      

                    }else{
                      //do the process for midblock
                      //review volume,class,speed
                      let _class=station.attributes.filter_classyear.split(",")
                      let _speed=station.attributes.filter_speedyear.split(",")
                      let _volume=station.attributes.filter_volumeyear.split(",")
                      
                      _class.forEach(function(value,index){
                        if(value.trim()!=""){
                          var arr = []
                          if(!classMap.has(value.trim())){
                            arr = [_station_id];
                            classMap.set(value.trim(), arr); 
                          } else {
                          arr = classMap.get(value.trim());
                          arr.push(_station_id);
                          }
                        }
                      })
                      _speed.forEach(function(value,index){
                        if(value.trim()!=""){
                            var arr = []
                            if(!speedMap.has(value.trim())){
                              arr = [_station_id];
                              speedMap.set(value.trim(), arr); 
                            } else {
                            arr = speedMap.get(value.trim());
                            arr.push(_station_id);
                            }

                        }
                        
                      })
                      _volume.forEach(function(value,index){
                        if(value.trim()!=""){
                            var arr = []
                            if(!volumeMap.has(value.trim())){
                              arr = [_station_id];
                              volumeMap.set(value.trim(), arr); 
                            } else {
                            arr = volumeMap.get(value.trim());
                            arr.push(_station_id);
                            }
                        }
                      })


                    }
                  })
                })
                watchUtils.whenTrue(view, "stationary", function (val) {
                  const query = geojsonLayer.createQuery();
                  // query.geometry = view.extent;
                  // query.spatialRelationship = "within";
                  watchUtils.whenFalseOnce(layerView, "updating", function (val) {

                    let query = gettingQueryWhere();
                    query.orderByFields = ["client_station_id ASC"];
                    //create query
                    layerView.queryFeatures(query).then(function(results){
                      if(!isLogin()){
                        results.features.forEach(function(station,index){
                          if(station.attributes.is_shared){
                            results.features[index].attributes.visible = 0; 
                          }
                        })
                      }
                      const {features} = results
                      previousResult = features; 
                      //setSearchResult([]);
                      setSearchResultv2(features)
                      if(!filterToggle && !polygonToggle && !activeImportFiles && !activeExportFiles){
                        setShowSearchWidgetResult(false)
                        layerView.effect={
                          filter:{
                            where:query.where
                          },
                          excludedEffect:"grayscale(100%) opacity(0%)"
                        }
                        setSearchChecked(true); 
                      }
                      if(!activeImportFiles && !activeExportFiles) {
                        if(filterToggle || _midblockChecked || _intersectionChecked || _popupTemplateChecked){
                          setSearchChecked(false); 
                        }else{
                          setSearchChecked(true); 
                        }
                      }
                    })
                  });
                });
              });
            })
              
             
            ////////////////////////////////////////
            //create custom source to format address 
            var customSearchSource = new SearchSource({              
              placeholder: "Search station names & IDs",                            
              name: "Address",
              displayField: "client_station_id",
              outFields: ["station_id", "client_station_id", "station_location", "station_type", "latitude", "longitude","display_name","all_approach"],
              // Provide a getSuggestions method
              // to provide suggestions to the Search widget
              getDictionary : function(value_to_searc){    
                let regex = new RegExp('/'+(Object.keys(DICTIONARY_TO_SEARCH).toString()).replaceAll(',','|')+'/gi');
                let newValueTosearhc = '';
                (value_to_searc.split(' ')).forEach(function(word){
                  newValueTosearhc += word.replace(regex, function(matched){
                    return DICTIONARY_TO_SEARCH[matched];
                  }) + ' ';
                });            
                
               return newValueTosearhc.trim();               
              },
              generateQuery : function(value_to_searc,value_to_searc_avv){
                var query = '',
                    query_avv = '';
                (value_to_searc.split(' ')).forEach(function(word){
                  query += (query == '') ? "lower(station_location) like '%"+word+"%'" : " AND lower(station_location) like '%"+word+"%'";
                });
                (value_to_searc_avv.split(' ')).forEach(function(word){
                  query_avv += (query_avv == '') ? "lower(station_location) like '%"+word+"%'" : " AND lower(station_location) like '%"+word+"%'";
                });
                let queryType = "";

                if(midIntFiltersIsHidden)
                  queryType = " AND station_type = 2 AND is_shared = 0";
                
                return "(("+query+") OR ("+query_avv+") OR (lower(display_name) like '%"+value_to_searc+"%') OR (lower(client_station_id) like '%"+value_to_searc+"%') OR (lower(all_approach) like '%"+value_to_searc+"%')) AND visible=1 "+queryType;                

              },
              getSearchQuery : function(value_to_searc,value_to_searc_avv){
                var query = geojsonLayer.createQuery();
                //query.where = "lower(station_location) like '%"+value_to_searc+"%' OR lower(station_location) like '%"+value_to_searc_avv+"%'";                             
                query.where = this.generateQuery(value_to_searc,value_to_searc_avv);
                query.outFields = ["station_id", "client_station_id", "station_location", "station_type", "latitude", "longitude","display_name","is_shared","visible","turningyear", "pedestrianyear", "bicycleyear","volumeyear", "classyear", "speedyear","haslane","capacityam","capacitymid","capacitypm"];

                return query;
              },
              getSuggestions: function(params) {                
                var value_to_searc = (params.suggestTerm).toLowerCase(),                
                    value_to_searc_avv = this.getDictionary(value_to_searc),
                    query = this.getSearchQuery(value_to_searc,value_to_searc_avv);                
                return geojsonLayer.queryFeatures(query).then(function(results){     
                  //slice array use to get the first 10 results             
                  return results.features.slice(0, 10).map(function(feature) {
                    return {
                      key: "station_location",
                      text: "("+feature.attributes.client_station_id+") "+((feature.attributes.display_name !='')?feature.attributes.display_name : feature.attributes.station_location),
                      searchText : feature.attributes.client_station_id,
                      sourceIndex: params.sourceIndex
                    };
                  });   
                });
              },
              getResults: function(params) {                
                let text_to_search = (params.suggestResult.sourceIndex == null)?params.suggestResult.text : params.suggestResult.searchText;                
                var value_to_searc = (text_to_search).toLowerCase(),                
                    value_to_searc_avv = this.getDictionary(value_to_searc),
                    query = this.getSearchQuery(value_to_searc,value_to_searc_avv);
                return geojsonLayer.queryFeatures(query).then(function(results){                  
                  return results.features.map(function(feature) {                                
                    // Create a Graphic the Search widget can display
                    var graphic = new Graphic({
                      geometry: new Point({
                        x: feature.geometry.x,
                        y: feature.geometry.y
                      }),
                      attributes: feature.attributes
                    });                                       
                    return {                      
                      feature: graphic,
                      name: feature.attributes.station_location
                    };                  
                  });
                });
              }
            });
            ////////////////////////////////////////////////
            ////////////////////////////////////////////////
            let search = getSearchWidget ? getSearchWidget : searchWidget;
            search.sources = [
              /*{
                layer: geojsonLayer,
                searchFields: ["station_location"],
                displayField: "station_location",
                exactMatch: false,
                outFields: ["station_id", "client_station_id", "station_location", "station_type", "latitude", "longitude"],
                name: "Station Location",
                placeholder: "Search"
              },              
              {
                layer: geojsonLayer,
                searchFields: ["display_name"],
                displayField: "display_name",
                exactMatch: false,
                outFields: ["station_id", "client_station_id", "station_location", "station_type", "latitude", "longitude"],
                name: "Display Name",
                placeholder: "Search"
              },
              {
                layer: geojsonLayer,
                searchFields: ["description"],
                displayField: "description",
                exactMatch: false,
                outFields: ["station_id", "client_station_id", "station_location", "station_type", "latitude", "longitude"],
                name: "Description",
                placeholder: "Search"
              },
              {
                layer: geojsonLayer,
                searchFields: ["all_approach"],
                displayField: "station_location",
                exactMatch: false,
                outFields: ["station_id", "client_station_id", "station_location", "station_type", "latitude", "longitude"]
                ,
                name: "Road Name",
                placeholder: "Search"
              },
              {
                layer: geojsonLayer,
                searchFields: ["client_station_id"],//description client_station_id all_approach
                displayField: "client_station_id",
                exactMatch: false,
                outFields: ["station_id", "client_station_id", "station_location", "station_type", "latitude", "longitude"],
                name: "Station Id",
                placeholder: "Search"
              },*/              
              customSearchSource
            ]
            setLoadSource(false);            
            //searchWidget.container = searchRef.current;
            search.container = document.getElementById("search-conainer-v2");
            setTempGeoLayer(geojsonLayer);
            // layers flag validation

            if(layersFlag === 'true'){
              getExternalLayers();
            }              
            else{

              //map.add(geojsonLayer);
            } 
              
          }
        }
        else {
          if ((searchChecked && zoomLevel == null) || geojsonLayer.visible == true) {        
            view.graphics.add(searchedStation);
          } else {
            importRemoveLocation(basemapView);
          }
        }
       
        view.popup = {
         
          dockEnabled: true,
          dockOptions: {
            breakpoint: false,
              buttonEnabled: false,
              position: "bottom-left"
          }
        };
        function findLayerByTitle(title) {
          return view.map.allLayers.find(function (layer) {
            
            return layer.title === title;
          });
        }
        let predominanceLayer;
         view.when(function () {
          featureLayer.when(function () {
            let vp = new Viewpoint({
              targetGeometry: featureLayer.fullExtent
            });
            homeButton.viewpoint = vp;
            //view.extent = tempView ? tempView.extent : featureLayer.fullExtent;
          });
          //map.add(featureLayer); // adds feature layer to map view
           
          if (geojsonLayer) {
            if (searchChecked || true) {
              if(layersFlag === 'true'){
              }              
              else{
              
                   //
           predominanceLayer = findLayerByTitle(
            "GeoJSON"
          );
           view.whenLayerView(predominanceLayer).then(function (layerView) {
            // Update the pie chart after the user stops panning or zooming
            watchUtils.whenTrue(view, "stationary", function (val) {
              watchUtils.whenFalseOnce(layerView, "updating", function (val) {
                
              });
            });
          });
           //
                map.add(geojsonLayer);
                polygonValidation();
              } 
            }
          }
        });

        /****/
        // this funcionality is to keep the filter params after login
        if(Cookies.get('payload') && Cookies.get('activeSearchFilter') && Cookies.get('activeSearchFilter') !== '') {
          let filterparams = JSON.parse(Cookies.get('activeSearchFilter'));
          // filter stations layer based on tht filter set before login
          showStationsByFilter(filterparams, map);
          clearCookie('activeSearchFilter');
        }
        // open stations details panel and highlight point based on the cookie set before log in
        if(Cookies.get('payload') && Cookies.get('activeSearchStation') && Cookies.get('activeSearchStation') !== '') {
          getStationDetail(JSON.parse(Cookies.get('activeSearchStation')));
        }
        // this funcionlaity is to keep the search params after login
        if(Cookies.get('payload') && Cookies.get('activeSearchText') && Cookies.get('activeSearchText') !== '') {
          let searchTerm = Cookies.get('activeSearchText');
          let searchRes = sessionStorage.getItem('activeSearchResult') ? JSON.parse(sessionStorage.getItem('activeSearchResult')) : [];
          setChecked(false);
          if (geolayer) {
            map.remove(geolayer);
            geolayer = null;
          }
          if (searchTerm !== "") { // get search results
            if(searchTerm !== "polygon")
            setSearchParam(searchTerm);
            _searchTxt = searchTerm;
            geojsonLayer.visible = true;
            sp = false;
            let searchDataArr = [];
            for (let i = 0; i < searchRes.length; i++) {
              if (searchRes.length > 0) {
                searchRes.map((value, index) => {
                  searchDataArr.push({
                    station_id: value.station_id,
                    client_station_id: value.client_station_id,
                    location: value.location,
                    station_location: value.location,
                    station_type: value.station_type,
                    latitude: value.latitude,
                    longitude: value.longitude,
                    class: '',
                    speed: '',
                    turning: '',
                    pedestrian: '',
                    bicycle: '',
                    volume: '',
                    checked: false,
                    is_shared:value.is_shared,
                    turningyear :value.turningyear,
                    pedestrianyear :value.pedestrianyear,
                    bicycleyear :value.bicycleyear,
                    volumeyear :value.volumeyear,
                    classyear :value.classyear,
                    speedyear :value.speedyear,
                    haslane: value.haslane,
                    capacityam: value.capacityam,
                    capacitymid: value.capacitymid,
                    capacitypm: value.capacitypm,
                    display_name: value.display_name,
                    all_approach: value.all_approach
                  })
                })
              }
            }
            searchDataArr = [...new Map(searchDataArr.map(item => [item.station_id, item])).values()];
            if (searchDataArr.length == 1) {
              setSelectedStationType(searchDataArr[0].station_type);
              setSelectedStation(searchDataArr[0].station_id);
              let plat = searchDataArr[0].latitude;
              let plong = searchDataArr[0].longitude;
              view.graphics.removeAll();
              var point = new Point(plong, plat);
              var pointSymbol = {
                type: "simple-marker",
                style: "circle",
                color: "#00A75D",
                size: 20,
                outline: {
                  color: "#00A75D",
                  width: 0.5
                }
              }
             
              if (searchDataArr[0].station_type==1){
                pointSymbol=symbolMidRed;
              }else{
                pointSymbol=symbolIntRed;
              }
              // Create a Graphic the Search widget can display
              var graphic = new Graphic({
                geometry: point, symbol: pointSymbol,
              });
              view.graphics.add(graphic);
              view.goTo(graphic).then(function () {
                view.zoom = view.zoom + 5;
              });
            }
            setZoomLevel(null);
            setSearchedStation(graphic);
            
            setSearchResult(searchDataArr);
            setShowSearchWidgetResult(true)
            searchedList = searchDataArr;
            setSearchChecked(true);
            setMutipleStationId([]);
          }
          clearCookie('activeSearchText');
          sessionStorage.removeItem('activeSearchResult');
        }
        /****/

        view.on('pointer-move', function (evt) {
          evt.stopPropagation();
          var screenPoint = {
            x: evt.x,
            y: evt.y
          };
          
          view.hitTest(screenPoint).then(function (response) {
            let _geolayer=[]

            _geolayer = response.results.filter((value) => {
              if(value.graphic.layer && value.graphic.layer.title=="GeoJSON"){
                 return value 
              }
              
            })
            
            try {
              if (response.results[0]) {
             
                let pointData = response.results[0].graphic.attributes;
                
                let pointDataGeoLayer = _geolayer[0]
               
                let layer_type=response.results[0].graphic.layer.type;
               
                let pointer_external_flag=false;                
                for (const temp_data in response.results) {
                  if(response.results[temp_data].graphic.layer.layer_type_a && response.results[temp_data].graphic.layer.layer_type_a=="external"){
                    pointer_external_flag=true;
                    

                  }
                  
                 

                }
               
                if (pointData && (pointDataGeoLayer!=undefined || pointData.clusterId || pointer_external_flag )) {
                  if (polygonToggle === false) 
                    document.getElementById("map_block").style.cursor = "pointer";
                }
                else {
                  if (polygonToggle === true) {
                    document.getElementById("map_block").style.cursor = "crosshair";
                  } else {
                    document.getElementById("map_block").style.cursor = "default";
                  }
                }
                
              }
            } catch (error) {
              console.error(error);
            }
          });
        });
 

        view.on("click", function (evt) {
          //setShowExternalLayers(true);
          if (showFileList == 'none') view.graphics.removeAll();
          if (document.getElementById('popup_template'))  {
            var element = document.getElementById("popup_template");
            element.parentNode.removeChild(element);
          } 

          //evt.stopPropagation();
          var screenPoint = {
            x: evt.x,
            y: evt.y
          };
         
          
         
          view.hitTest(screenPoint).then(function (response) {
            
              let _geolayer=[]

              _geolayer = response.results.filter((value) => {
                if(value.graphic.layer && value.graphic.layer.title=="GeoJSON"){
                   return value 
                }
                
              })
            
              response.results=_geolayer
            view.popup.watch("selectedFeature", function(graphic) {
             
               if (graphic) {
                 var graphicTemplate = graphic.getEffectivePopupTemplate();
                 document.getElementById("map_block").style.cursor = "pointer";
                 let arrayContent =[]
                 let existLatLng = false;
                 for (const property in graphic.attributes) {
                  
                   if((typeof property)=="string"){
                    if(property.toLocaleLowerCase() === "latitude" || property.toLocaleLowerCase() === "longitude"){
                      existLatLng = true;
                    }
                     arrayContent.push([property,graphic.attributes[property]])
                   }
                  }
                  if(graphic.geometry.longitude && graphic.geometry.latitude && !existLatLng) {
                   arrayContent.push(["LATITUDE", graphic.geometry.latitude]);
                   arrayContent.push(["LONGITUDE", graphic.geometry.longitude]);
                  }
                
                 if(graphic.attributes.STOPTYPE && graphicTemplate.title==='Bus stop'){
                   
                   let symbolBus = {
                    type: "picture-marker",  // autocasts as new PictureMarkerSymbol()
                    url: require("../../assets/icons/map/bus-selected.svg"),
                    width: "34px",
                    height: "34px"
                  };
                  let long = graphic.geometry.longitude;
                  let lat = graphic.geometry.latitude;

                  view.graphics.removeAll();
                  let point = new Point(long, lat);
                  var graphic = new Graphic({
                    geometry: point,
                    symbol: symbolBus,
                  });
                 
                  view.graphics.add(graphic);
                 }

                 if(graphic.geometry.longitude && graphic.geometry.latitude && !existLatLng) {
                  arrayContent.push(["LATITUDE", graphic.geometry.latitude]);
                  arrayContent.push(["LONGITUDE", graphic.geometry.longitude]);
                 }
               if(flag){

                
                setPopupTitle(graphicTemplate.title)
                setPopupContent(arrayContent)
              
                setPopuptemplateChecked(true);
                _popupTemplateChecked = true;
                setMidblockChecked(false)
                setIntersectionChecked(false)
                setSearchChecked(false);
                setDetailsPanel(false);
                
               }
                 
                
               }
    
          
            });

            flag=true
           
            if (importDataMapPoint == true) {
              try {
                let pointData = response.results[0].graphic.attributes;
                let selectedData = response.results[0].graphic.geometry;
                
                
                if (pointData && pointData.station_id) {
                  let stationId = pointData.station_id;
                  let clientStationId = pointData.client_station_id;
                  let stationLocation = pointData.station_location;
                  let stationStatus = pointData.status;
                  let long = selectedData.longitude;
                  let lat = selectedData.latitude;

                  view.graphics.removeAll();
                  let point = new Point(long, lat);

                  let pointSymbol = {
                    type: "simple-marker",
                    style: "circle",
                    color: "#00A75D",
                    size: 20,
                    outline: {
                      color: "#00A75D",
                      width: 0.5
                    }
                  }

                  if (pointData.station_type==1 ){
                    if(pointData.visible==1 && pointData.is_shared==0){
                      pointSymbol=symbolMidRed;
                    }else if(pointData.visible==1 && pointData.is_shared==1){
                      pointSymbol=symbolMid_sharedRed;
                    }
                    
                  }else{
                    if(pointData.visible==1 && pointData.is_shared==0){
                      pointSymbol=symbolIntRed;
                    }else if(pointData.visible==1 && pointData.is_shared==1){
                      pointSymbol=symbolInt_sharedRed;
                    }
                    
                  }

                  let graphic = new Graphic({
                    geometry: point, symbol: pointSymbol,
                  });
                  view.graphics.add(graphic);
                
                  setUseSationId(stationId, clientStationId, stationLocation, stationStatus, long, lat);
                }
                else if (pointData && pointData.clusterId) {
             

                  let point = new Point({
                    longitude: selectedData.longitude,
                    latitude: selectedData.latitude,
                  });

                  let pointGraphic = new Graphic(point, null);

                  view.goTo(pointGraphic).then(function () {
                    view.zoom = view.zoom + 4;
                  });
                }
                else { }
              }
              catch (error) {
                console.error(error);
              }
            }
            else if (response.results.length && sp == false && response.results[0].graphic.attributes) {
              let plat = response.results[0].graphic.attributes.latitude;
              let plong = response.results[0].graphic.attributes.longitude;
              let client_station_id = response.results[0].graphic.attributes.client_station_id;
              let station_type = response.results[0].graphic.attributes.station_type;
              let cluster_id = response.results[0].graphic.attributes.clusterId;
              let selectedData = response.results[0].graphic.geometry;
              let station_id = response.results[0].graphic.attributes.station_id;
              
              let is_shared =response.results[0].graphic.attributes.is_shared
              let visible =response.results[0].graphic.attributes.visible
            
            
              if (cluster_id != null) {
                var esri_goto_option = {
                  animate: true,
                  duration: 200,
                  };
           
                  let point = new Point({
                    latitude: selectedData.latitude,
                    longitude: selectedData.longitude
                  });
                
                view.goTo({
                  
                  target: point,
                
                }, esri_goto_option)          
                .catch(function(error) {
                
                  if (error.name != "AbortError") {
                  console.error('zoom to real location, view goto error', error);
                  }
                
                
                });
                view.zoom=view.zoom+4
              }
              else if (client_station_id && station_type && !polygonToggle) {
              
              
                getStationDetail(station_id);
                flag=false
                setPopuptemplateChecked(false);
                _popupTemplateChecked = false;

                let stationExists = searchedList.some(ele => ele.client_station_id === client_station_id);
                if (stationExists == true) {
                  setMidblockChecked(false);
                  setIntersectionChecked(false);
                  setSelectedStation(client_station_id);
                  setSelectedStationType(station_type);
                } else {
                  getStationDetail(station_id);
                }
                view.graphics.removeAll();
                var point = new Point(plong, plat);

                var pointSymbol = {
                  type: "simple-marker",
                  style: "circle",
                  color: "#00A75D",
                  size: 20,
                  outline: {
                    color: "#00A75D",
                    width: 0.5
                  }
                }
            
                if (station_type==1 ){
                  if(visible==1 && is_shared==0){
                    pointSymbol=symbolMidRed;
                  }else if(visible==1 && is_shared==1){
                    pointSymbol=symbolMid_sharedRed;
                  }
                  
                }else{
                  if(visible==1 && is_shared==0){
                    pointSymbol=symbolIntRed;
                  }else if(visible==1 && is_shared==1){
                    pointSymbol=symbolInt_sharedRed;
                  }
                  
                }

                // Create a Graphic the Search widget can display
                var graphic = new Graphic({
                  geometry: point,
                  symbol: pointSymbol,
                });
                setSearchedStation(graphic);
                view.graphics.add(graphic);
              }
            }
            else {
              if (response.results[0] && response.results[0].graphic && response.results[0].graphic.attributes) {
                let my_station_id = response.results[0].graphic.attributes.station_id;
                let cluster_id = response.results[0].graphic.attributes.clusterId;
                let selectedData = response.results[0].graphic.geometry;
                let station_type =response.results[0].graphic.attributes.station_type
               
          
                let is_shared =response.results[0].graphic.attributes.is_shared
                let visible =response.results[0].graphic.attributes.visible
              
               
                if (cluster_id != null) {
                  
                  var esri_goto_option = {
                    animate: true,
                    duration: 200,
                    };
             
                  let point = new Point({
                    longitude: selectedData.longitude,
                    latitude: selectedData.latitude,
                  });
                  
                  view.goTo({
                    
                    target: point,
                  
                  }, esri_goto_option)          
                  .catch(function(error) {
                  
                    if (error.name != "AbortError") {
                    console.error('zoom to real location, view goto error', error);
                    }
                  
                  
                  });
                  view.zoom=view.zoom+4

                  setMidblockChecked(false);
                  setIntersectionChecked(false);
                  setImportFilesListChecked(false);
                  view.graphics.removeAll();
                }
                else if (my_station_id && my_station_id != "") {
                  if(!activeImportFiles && !activeExportFiles && !polygonToggle) {
                    //
                    getStationDetail(my_station_id);
                    flag=false
                    setPopuptemplateChecked(false);
                    if(!Cookies.get('payload')) {
                      setCookie('activeSearchStation', my_station_id);
                    }
  
  
                    let pointSymbol = {
                      type: "simple-marker",
                      style: "circle",
                      color: "#00b15e",
                      size: 20,
                      outline: {
                        color: "#3676bc",
                        width: 0.5
                      }
                    };

                    if (station_type==1 ){
                      if(visible==1 && is_shared==0){
                        pointSymbol=symbolMidRed;
                      }else if(visible==1 && is_shared==1){
                        pointSymbol=symbolMid_sharedRed;
                      }
                      
                    }else{
                      if(visible==1 && is_shared==0){
                        pointSymbol=symbolIntRed;
                      }else if(visible==1 && is_shared==1){
                        pointSymbol=symbolInt_sharedRed;
                      }
                      
                    }

                    let point = new Point({
                      longitude: selectedData.longitude,
                      latitude: selectedData.latitude,
                    });
  
                    let pointGraphic = new Graphic(point, pointSymbol);
                    setSearchedStation(pointGraphic);
                    view.graphics.add(pointGraphic);
                    setMyView(view); 
                  } else {
                    setActiveStationIDSel(my_station_id);
                  }
                }
              }
            };
          })
        });
        setHome(homeButton)
        setZoom(zoom)
        setLocate(locate)
        setMeasurement(measure)
        //call goStation
        goToStation()

        return () => {
          if (view) {
            view.container = null;
          }
        };
      })
  }
  //This method is use for mapview and handle all map event .... end
  
  //This method is use for call geoJsonData to show station  by using geoJsonLayer .... Start
  const getGeoJsonData = async () => {
    try {
      let headers = Cookies.get('payload')
        ? {
          'agencyid': sessionStorage.getItem('agency_id'),
          'payload': Cookies.get('payload'),
        }
        : {
          'agencyid': sessionStorage.getItem('agency_id'),
        }
      //this code is create Geojson marker
      return axios({
        method: 'get',
       url: API_URL + API_PATH.stationListGeov2,
       //url: "http://localhost:8080/api/v1/station/stationlistGeov2",
       
      
        headers: headers,
      }).then(function (response) {
        if (response && response.status && response.status == '200') {
          let myGeoJsonLayerData = response.data.data;
          setGeoLayerData(myGeoJsonLayerData);
          return myGeoJsonLayerData;
        }
      })
    } catch (error) {
      console.error(error);
    }
  }
  //This method is use for call geoJsonData to show station  by using geoJsonLayer .... end

  const handleSearchResults = () => {
    setSearchChecked((prev) => !prev);
    searchedList = [];
    tempView.graphics.removeAll();
    tempGeoLayer.visible = false;
    if (geolayer) {
      mapView.remove(geolayer);
      geolayer = null;
    }
    setSearchChecked(false);
    setSearchParam('');
    _searchTxt = "";
    if (getSearchWidget) getSearchWidget.clear();
    sp = true;
    geojsonLayer.visible = true;
    if(Cookies.get('polygonExtent') || (Cookies.get('activeSearchText')  && Cookies.get('activeSearchText') === 'polygon')) {
      clearCookie('polygonExtent');
      clearCookie('activeSearchText');
    }
    
    clearFilterStations();
  };

  const cardOut = (latitude, longitude, client_station_id, station_type,visible,is_shared, tmpView=null) => {
    if(tempViewPinState) tempViewPinState.graphics.removeAll();
  }
  const cardOver = (latitude, longitude, client_station_id, station_type,visible,is_shared, tmpView=null) => {
    setZoomLevel(null);
    if (selectedStation !== client_station_id) {
      loadModules(["esri/geometry/Point", "esri/Graphic"], { css: true })
        .then(async ([Point, Graphic]) => {
         // setSelectedStation(client_station_id);
        //  setSelectedStationType(station_type);
          let plat = latitude;
          let plong = longitude;
          if(tempViewPinState) tempViewPinState.graphics.removeAll();

          var point = new Point(plong, plat);
          
          var pointSymbol = {
            type: "simple-marker",
            style: "circle",
            color: "#00A75D",
            size: 20,
            outline: {
              color: "#00A75D",
              width: 0.5
            }
          }

          if (station_type==1 ){
            if(visible==1 && is_shared==0){
              pointSymbol=symbolMidRed;
            }else if(visible==1 && is_shared==1){
              pointSymbol=symbolMid_sharedRed;
            }
            
          }else{
            if(visible==1 && is_shared==0){
              pointSymbol=symbolIntRed;
            }else if(visible==1 && is_shared==1){
              pointSymbol=symbolInt_sharedRed;
            }
          }
          // Create a Graphic the Search widget can display
          var graphic = new Graphic({
            geometry: point, 
            symbol: pointSymbol,
          });
       //   setSearchedStation(graphic);
          if(tempView) {
            //tmpView.zoom = 14;
            /*tmpView.goTo(graphic).then(function () {           
              tmpView.zoom = tmpView.zoom + 5;
            });
*/            
            tempViewPinState.graphics.add(graphic);
          } else {
           //    tempView.zoom = 14;
           /* tempView.goTo(graphic).then(function () {           
              tempView.zoom = tempView.zoom + 5;
            });*/
           
          }
        })
    }

  }
  const highlightStation = (latitude, longitude, client_station_id, station_type,visible,is_shared, tmpView=null) => {
    setZoomLevel(null);
    if (selectedStation !== client_station_id) {
      loadModules(["esri/geometry/Point", "esri/Graphic"], { css: true })
        .then(async ([Point, Graphic]) => {
         // setSelectedStation(client_station_id);
        //  setSelectedStationType(station_type);
          let plat = latitude;
          let plong = longitude;
          if(tmpView) tmpView.graphics.removeAll(); else tempView.graphics.removeAll();

          var point = new Point(plong, plat);
          
          var pointSymbol = {
            type: "simple-marker",
            style: "circle",
            color: "#00A75D",
            size: 20,
            outline: {
              color: "#00A75D",
              width: 0.5
            }
          }
        
          if (station_type==1 ){
            if(visible==1 && is_shared==0){
              pointSymbol=symbolMidRed;
            }else if(visible==1 && is_shared==1){
              pointSymbol=symbolMid_sharedRed;
            }
            
          }else{
            if(visible==1 && is_shared==0){
              pointSymbol=symbolIntRed;
            }else if(visible==1 && is_shared==1){
              pointSymbol=symbolInt_sharedRed;
            }
          } 

          // Create a Graphic the Search widget can display
          var graphic = new Graphic({
            geometry: point, symbol: pointSymbol,
          });
       //   setSearchedStation(graphic);
          if(tmpView) {
            //tmpView.zoom = 14;
            tmpView.goTo(graphic).then(function () {           
              //tmpView.zoom = tmpView.zoom + 5;
            });
            tmpView.graphics.add(graphic);
          } else {
           //    tempView.zoom = 14;
            tempView.goTo(graphic).then(function () {           
              tempView.zoom = tempView.zoom + 5;
            });
            tempView.graphics.add(graphic);
          }
          //if (getSearchWidget) getSearchWidget.clear();
        })
    }
  }
 
  const getStationDetail = (station_id,highlight=false) => {  
    setLoadingDetails(true);
    if(!Cookies.get('payload')) {
      setCookie('activeSearchStation', station_id);
    }
    sessionStorage.setItem("stationIdDetails", station_id);
    try {
      axios({
        method: 'get',
        url: API_URL + API_PATH.getStationDetail + station_id,
      })
        .then(async function (response) {
          let tmpStation = response.data.data;
          if(Cookies.get('payload') && Cookies.get('activeSearchStation')) {
            highlightStation(tmpStation.latitude, tmpStation.longitude, station_id, tmpStation.station_type,tmpStation.visible,tmpStation.is_shared, view);
            clearCookie('activeSearchStation');
          }     
          //highlight station
          if(highlight){           
            highlightStation(tmpStation.latitude, tmpStation.longitude, station_id, tmpStation.station_type,1,0, view);   
            view.zoom = 14;
            clearCookie('activeSearchStation'); 
          }     
          //review shared
          let shared = (tmpStation?.is_shared && tmpStation.FK_agency_id != sessionStorage.getItem('agency_id'))?true : false;
          let sharedBy = (shared)?tmpStation.agency : '';
          setSharedStation(shared);
          setSharedAgencyName(sharedBy);
          //
          
          //details
          setDetailsPanel(true);
          setSearchChecked(false);
          response.data.data.is_shared = shared;
          setPanelStationData(response.data.data)               
          //
          if (response.data.data.station_type_name === "Midblock") {   
            let midblockStationRecentYear = await getMidblockStationRecentYear(station_id);            
            let midblockHasData = (midblockStationRecentYear.length !=0 && (midblockStationRecentYear.volumeyear!='' || midblockStationRecentYear.classyear!='' || midblockStationRecentYear.speedyear!=''))?true:false;
            if(midblockHasData){              
              let midblockSummaryData = await getMidblockSummaryData(station_id);
              let midblockADTeChart = await getMidblockADTeChart(station_id);
              setDetailsPanelMidblock({
                midblockStationRecentYear : midblockStationRecentYear,
                midblockSummaryData : midblockSummaryData,
                midblockADTeChart : midblockADTeChart
              })
            }else{
              setDetailsPanelMidblock({
                midblockStationRecentYear : midblockStationRecentYear,
                midblockSummaryData : {},
                midblockADTeChart : {}
              })
            }
            setHasData(midblockHasData);        
            setMidblockChecked(true);
            setIntersectionChecked(false);    
            setImportFilesListChecked(false);        
          }
          else if (response.data.data.station_type_name === "Intersection") {  
            let intersentionRecentYear = await getIntersentionRecentYear(station_id); 
            let intersectionHasData = (intersentionRecentYear.length !=0 && (intersentionRecentYear.turningyear !='' || intersentionRecentYear.pedestrianyear !='' || intersentionRecentYear.bicycleyear !=''))?true : false;                         
            if(intersectionHasData){                          
              let intersectionDatePeakData = await getIntersectionDatePeakData(station_id);            
              let intersectionTurningMovement = await getIntersectionTurningMovement(intersectionDatePeakData.timeData,station_id);            
              let intersectionTruckPercentage = await getIntersectionTruckPercentage(intersectionDatePeakData.timeData,station_id);            
              let intersectionPedestrianMovement = await getIntersectionPedestrianMovement(intersectionDatePeakData.timeData,station_id);            
              let intersectionBicycleMovement = await getIntersectionBicycleMovement(intersectionDatePeakData.timeData,station_id);
              let intersectionBicycleCrosswalkMovement = await getIntersectionBicycleCrosswalkMovement(intersectionDatePeakData.timeData,station_id);      
              let intersectionLaneGeometryMovement = await getIntersectionLaneGeometryMovement(station_id);                                          
              setDetailsPanelIntersection({
                intersentionRecentYear : intersentionRecentYear,
                intersectionDatePeakData : intersectionDatePeakData,
                intersectionTurningMovement : intersectionTurningMovement,
                intersectionTruckPercentage : intersectionTruckPercentage,
                intersectionPedestrianMovement : intersectionPedestrianMovement,
                intersectionBicycleMovement : intersectionBicycleMovement,
                intersectionBicycleCrosswalkMovement : intersectionBicycleCrosswalkMovement,
                intersectionLaneGeometryMovement : intersectionLaneGeometryMovement
              });
            }else{
              setDetailsPanelIntersection({
                intersentionRecentYear : intersentionRecentYear,
                intersectionDatePeakData : {},
                intersectionTurningMovement : {},
                intersectionTruckPercentage : {},
                intersectionPedestrianMovement : {},
                intersectionBicycleMovement : {},
                intersectionBicycleCrosswalkMovement : {},
                intersectionLaneGeometryMovement : {}
              });
            }
            
            setHasData(intersectionHasData);        
            setIntersectionChecked(true);
            setMidblockChecked(false);
            setImportFilesListChecked(false);
           
          }
          else { }
          setLoadingDetails(false);
        })
        .catch(function (error) {
          console.log(error);
        })
    } catch (error) {
      console.error(error);
    }
  }

const returnMainLIstPanel = () => {
  handleActiveExportFiles(false); 
  setDetailsPanel(false);
  setSearchChecked(true);  
  setMidblockChecked(false)
  setIntersectionChecked(false)
  setImportFilesListChecked(false);
  if(tempViewPinState) tempViewPinState.graphics.removeAll();
  if(view) view.graphics.removeAll();
  //if (home) home.go();  
  //update view
  //view.zoom = view.zoom +1;
  //view.zoom = view.zoom -1;
  if(polygonToggle) {
    // show station list within the polygon selection
    setShowSearchWidgetResult(true)
    setSearchResult(previousResultForPolygon);
    setSearchResultv2([]);
  } else {
    // show station list based on the zoom and filters
    //setSearchResultv2(previousResult);
    //if (getSearchWidget) getSearchWidget.clear();
  }
  
}

  //This method is use for get station details for check the station type and open station penel .... end

  const searchPanel = () => {
    setSearchChecked(true);
  }

  //This method is use for show the available on filter ... start
  const showStationsByFilter = (filters, map_view=null) => {
    importDataMapPoint= false;
    setDetails([]);
    setMapLocation([]);
    setShowFileList('none');
    setLoaderShow('block');
    setShowimportData('none');
    setGeoJSONNF(false);
    setMidblockChecked(false);
    setIntersectionChecked(false);
    setImportFilesListChecked(false);
    if(!map_view) {
      removeMatchLocation();
      getSearchWidget.disabled = false;
      try {
        tempView.graphics.removeAll();
      } catch (e) {
        console.log("error : ", e)
      }
    }
    let apiData = {
      startdate: filters.startDate,
      enddate: filters.endDate,
      selected_type: filters.selected_type
    }
    for (let [key, value] of Object.entries(filters)) {
      if (value == true) {
        apiData[key] = value;
      }
    }
    loadModules(["esri/layers/GeoJSONLayer", "esri/layers/FeatureLayer", "esri/Viewpoint"], { css: true })
      .then(([GeoJSONLayer, FeatureLayer, Viewpoint]) => {

        let headers = Cookies.get('payload')
          ? {
            'agencyid': sessionStorage.getItem('agency_id'),
            'payload': Cookies.get('payload'),
          }
          : {
            'agencyid': sessionStorage.getItem('agency_id'),
          }

        axios({
          method: 'post',
          data: apiData,
          headers: headers,
          url: API_URL + API_PATH.filterStation,
        })
          .then(async function (response) {
            if (response.data.data.features == null || response == undefined) {
              setErrPopUp(true);
              setGeoJSONNF(true);
              setLoaderOff(false);
            } else {
              setSearchChecked(false);
              sp = true;
              setErrPopUp(false);
              setGeoJSONNF(false);
              // setLoaderOff(false);
              loaderFunction()
              const GeoJSONBlob = new Blob([JSON.stringify(response.data.data)], { type: "application/json" });
              const GeoJSONUrl = URL.createObjectURL(GeoJSONBlob);

              const renderer = {
                type: "simple",
                field: "station_id",
                symbol: {
                  type: "simple-marker",
                  style: "circle",
                  color: "#24618e",
                  size: 14,
                  outline: {
                    color: "#00A75D",
                    width: 0.5
                  }
                }
              }

              
              const cluster = {
                type: "cluster",
                clusterRadius: "50px",
               /* popupTemplate: {
                  content: "This cluster represents {cluster_count} stations."
                },*/
                clusterMinSize: "40px",
                clusterMaxSize: "40px",
                labelingInfo: [{
                  deconflictionStrategy: "none",
                  labelExpressionInfo: {
                    expression: "Text($feature.cluster_count, '#,###')"
                  },
                  symbol: {
                    type: "text",
                    color: "#fff",
                    font: {
                      weight: "bold",
                      family: "Noto Sans",
                      size: "18px"
                    }
                  },
                  labelPlacement: "center-center",
                }]
              }
              geojsonLayer.visible = false;
              if(!map_view)
                removeAllMapLocations();
              geolayer = new GeoJSONLayer({
                url: GeoJSONUrl,
                featureReduction: cluster,
                renderer: renderer
              });
              myGeoLayer = geolayer;
              // homeEvent();
              if(map_view) {
                map_view.add(myGeoLayer);
                map_view.zoom = mapView.zoom + 4;
              } else {
                mapView.add(myGeoLayer);
                mapView.zoom = mapView.zoom + 4;
              }
              // await setCookie('geolayer', geolayer);
              handlePopUp();
              setLoaderOff(false);
            }
          })
          .catch(function (error) {
            console.log("error : ", error)
            setErrPopUp(true);
            setGeoJSONNF(true);
            setLoaderOff(true);
          })
      })
  }
  //This method is use for show the available on filter ... end

  const handlePopUp = () => {
    setMapLayer(!getMapLayer);
    setLoaderOff(false);
    setGeoJSONNF(false);
    setChecked((prev) => !prev);
  };

  const handleMidBlock = () => {
    let pointView = myView;
   
    setSearchedStation(null);
    setMidblockChecked((prev) => !prev);
    try {
      if (pointView) {
        pointView.graphics.removeAll();
      }
    } catch (e) {
      console.log("error : ", e)
    }
  };

  const handlePopBlock = () => {
    let pointView = myView;
    setPopuptemplateChecked(false);
    _popupTemplateChecked = false;
    setSearchChecked(true);
    try {
      if (pointView) {
        pointView.graphics.removeAll();
      }
    } catch (e) {
      console.log("error : ", e)
    }
    if (geojsonLayer && geojsonLayer.visible) {
      geojsonLayer.opacity = 1;
    }
  };

  const handleIntersection = () => {
    let pointView = myView;
    setSearchedStation(null);
    
    setIntersectionChecked((prev) => !prev);
    try {
      if (pointView) {
        pointView.graphics.removeAll();
      }
    } catch (e) {
      console.log("error : ", e)
    }
  };

  const exportpopUp = () => {
    
    if (exportChecked == 'none') {
      setExportChecked('block');
    }
    else {
      setExportChecked('none');
      //setMutipleStationId([]);
    }
  }

  const exportpopUpDetails = () => {
    
    if (exportCheckedDetails == 'none') {
      setExportCheckedDetails('block');
    }
    else {
      setExportCheckedDetails('none');
    }
  } 

  const locationEvent = () => { // event to locate current position
    locate.locate();
    locate.on("locate", function (locateEvent) {
    })
  }

  const homeEvent = () => { // event to go at initial view
    home.go();
    home.on("go", function (event) {
    });
    


    basemapView.graphics.removeAll()
  }

  const ZoomInEvent = () => { // event to zoom in map
    zoom.zoomIn();

  }

  const zoomOutEvent = () => { // event to zoom out map
    zoom.zoomOut();
  }

  /* This function is for handle import data pop up */
  const getStationId = () => {
    try {
      axios({
        method: 'get',
        url: API_URL + API_PATH.getAllStationsByAgencyAPI,
        headers: {
          'agencyid': sessionStorage.getItem('agency_id'),
          'payload': Cookies.get('payload'),
        },
      }).then(async function (response) {
        if (response.status && response.status == '200') {
          stationData = response.data;
          stationData = stationData.data;
          for (let i = 0; i < stationData.length; i++) {
            stationIDData.push({ station_id: stationData[i].station_id, stationId: stationData[i].client_station_id });
          }
          setStationDetails([...stationDetails, ...stationIDData]);
        } else {
          console.log("Do Not Get Any Station ID");
        }
      }).catch(async function (error) {
        if (error.response) {
          if (error.response.status && error.response.status == '401') {
            if (Cookies.get('email')) {
              clearCookie('email');
              clearCookie('payload');
              clearCookie('idToken');
              clearCookie('atexpiry');
            }
            history.push('/');
          }
        }
      })
    } catch (error) {
      console.error(error);
    }
  }

  const changeMapView = (tempDeta) => {
    if (geojsonLayer.visible) {
      geojsonLayer.opacity = 0.5;
    }

    tempView.graphics.removeAll();
    // importRemoveLocation();
    // lazy load the required ArcGIS API for JavaScript modules and CSS
    loadModules(["esri/geometry/Point", "esri/Graphic"], { css: true })
      .then(([Point, Graphic]) => {
        let stationsData = geoLayerData ? geoLayerData.features : [];
        let pointSymbol;
        for (let i = 0; i < stationsData.length; i++) {
          if (tempDeta !== '') {
            tempDeta.map((mpl, index) => {
              if (stationsData[i].properties.client_station_id === mpl.clent_Station_id) {
                if(stationsData[i].properties.station_type === 1) {
                  pointSymbol = {
                    type: "picture-marker",  // autocasts as new PictureMarkerSymbol()
                    url: require("../../assets/icons/map_pin_mid.png"),
                    width: "40px",
                    height: "40px"
                  }
                } else {
                  pointSymbol = {
                    type: "picture-marker",  // autocasts as new PictureMarkerSymbol()
                    url: require("../../assets/icons/map_pin_int.png"),
                    width: "40px",
                    height: "40px"
                  }
                }
                point = new Point({
                  longitude: stationsData[i].properties.longitude,
                  latitude: stationsData[i].properties.latitude,
                });
                pointGraphic = new Graphic(point, pointSymbol);
                tempView.graphics.add(pointGraphic);
              }
            });
          }
        }
      });
  }

  const removeMatchLocation = () => {
    tempView.graphics.removeAll();
  }
 
  const setUseSationId = (stationId, clientStationId, stationLocation, stationStatus, long, lat) => {
    setIdIndex(myIndexValue);
    setShowimportData('none');
    setShowUseStationData('block');
    setFileCountData('none');
    setShowImportButton('none');
    getUseStationDetails(stationId, clientStationId, stationLocation, stationStatus, long, lat);
  }

  const getUseStationDetails = (stationId, clientStationId, stationLocation, stationStatus, long, lat) => {
    try {
      setUseStationId(clientStationId);
      setUseStationLocation(stationLocation);
      setUseStationLat(lat);
      SetUseStationLong(long);
      SetUseStationStatus(stationStatus);
    } catch (error) {
      console.error(error);
    }
  }

  const removeAllMapLocations = async () => {
    let myGeo = Cookies.get('geoJsonLayer');
    mapView.remove(geoLayer);
    mapView.remove(myGeoLayer);
    mapView.remove(myGeo);
    await clearCookie('geoJsonLayer');
  }

  const importRemoveLocation = (basemapView = null) => {
    let view;
    if (basemapView) {
      view = basemapView;
    } else {
      view = tempView;
    }
    view.graphics.removeAll();
    // lazy load the required ArcGIS API for JavaScript modules and CSS
    loadModules(["esri/geometry/Point", "esri/Graphic", "esri/symbols/PictureMarkerSymbol", "esri/PopupTemplate"], { css: true })
      .then(([Point, Graphic, PictureMarkerSymbol]) => {
        //This Code is used for Marker Point              
        try {
          for (let i = 0; i < details.length; i++) {
            if (details[i].sationId !== '') {
              let items = allStationList;
              let data;
              let long;
              let lat;
              data = items.filter(item => item.client_station_id === details[i].sationId);
              long = data[0].longitude;
              lat = data[0].latitude;
              let pointSymbol = {
                type: "simple-marker",
                style: "circle",
                color: "#24618e",
                size: 14,
                outline: {
                  color: "#00A75D",
                  width: 0.5
                }
              }
              point = new Point({
                longitude: long,
                latitude: lat,
              });
              pointGraphic = new Graphic(point, pointSymbol);
              view.graphics.add(pointGraphic);
            }
          }
        } catch (error) {
          console.error(error);
        }
      });
  }

  /* This funtion is call for stored multiple station Id start*/
  const multipleStations = (event, selected_Station, station_type, client_Station_Id, Station_location) => {
    let indexExprot = multipleStationId.findIndex((ele, index) => ele.station_id === selected_Station);
    if (event == true) {
      if (indexExprot === -1) {
        setMutipleStationId([...multipleStationId, { station_id: selected_Station, station_type: station_type, client_Station_Id: client_Station_Id, Station_location: Station_location }]);
      } 
    }
    else {
      if (indexExprot !== -1) {
        let newArr = multipleStationId;
        newArr.splice(indexExprot, 1);
        setMutipleStationId(newArr);
      }
    }

  }
  /* This funtion is call for stored multiple station Id end*/

  /* This funtion is call for stored single Station station Id start*/
  const singleMidblockStations = (selected_Station, station_type, client_Station_Id, Station_location) => {
    setSingleMidblockStationId([{ station_id: selected_Station, station_type: station_type, client_Station_Id: client_Station_Id, Station_location: Station_location }]);
  }
  /* This funtion is call for stored single station Id end*/

  /* This funtion is call for stored single Station station Id start*/
  const singleIntersectionStations = (selected_Station, station_type, client_Station_Id, Station_location) => {
    setSingleIntersectionStationId([{ station_id: selected_Station, station_type: station_type, client_Station_Id: client_Station_Id, Station_location: Station_location }]);
  }
  /* This funtion is call for stored single station Id end*/

  /* This funtion is call for stored all station Id start*/
  const allStations = (e, station_type, stationsArr, maxFileNum) => {
    let tempArray = [];
    if (e) {
      if (stationsArr.length > 0) {
        let counter = 0;
        for (let i = 0; i < stationsArr.length; i++) {
          if(counter < maxFileNum) {
            let cStation = stationsArr[i];
            let indexExprot = multipleStationId.findIndex((ele, index) => ele.station_id === stationsArr[i].station_id);
            if (indexExprot === -1) {
              if(cStation.station_type === 1 && (cStation.volumeyear !== "" || cStation.classyear !== "" || cStation.speedyear !== "")) {
                counter++;
                tempArray.push({ station_id: stationsArr[i].station_id, station_type: stationsArr[i].station_type, client_Station_Id: stationsArr[i].client_station_id, Station_location: stationsArr[i].location });
              } else if (cStation.station_type === 2 && (cStation.turningyear !== "" || cStation.bicycleyear !== "" || cStation.pedestrianyear !== "")) {
                counter++;
                tempArray.push({ station_id: stationsArr[i].station_id, station_type: stationsArr[i].station_type, client_Station_Id: stationsArr[i].client_station_id, Station_location: stationsArr[i].location });
              }
            }
          }
        }
        // setMutipleStationId([...multipleStationId, ...tempArray]);
        setMutipleStationId(tempArray);
      }
    } else {
      // let dataArray = multipleStationId;
      // for (let i = 0; i < maxFileNum; i++) {
      //   let indexExprot = multipleStationId.findIndex((ele, index) => ele.station_id === stationsArr[i].station_id);
      //   if (indexExprot !== -1) {
      //     dataArray.splice(indexExprot, 1);
      //   }
      // }
      setMutipleStationId([]);
    }
    // setMutipleStationId([...multipleStationId, ...tempArray]);
  }
  /* This funtion is call for stored multiple station Id end*/

  const clearFilterStations = () => {
    //remove filter from stations layers
    let featureFilter = {
      geometry: null
    };
    if (geojsonLayer.visible && featureLayerView) {
      featureLayerView.effect = {
        filter: featureFilter,
        excludedEffect: "opacity(50%)"
      };
    } 
    // else if(filterLayerView) {
    //   filterLayerView.effect = {
    //     filter: featureFilter,
    //     excludedEffect: "opacity(50%)"
    //   };
    // }
  }

  const clearFilterExternalLayers = () => {
    //remove filter from external layers
    let featureFilter = {
      geometry: null
    };
    // effect to excluded features from external layers
    featurExternalLayerView.forEach(function(extLay){
      if (extLay) {
        extLay.effect = {
          filter: featureFilter,
          excludedEffect: "opacity(50%)"
        };
      }
    })
  }

  const gettingQueryWhere = () => {

    let query = {};
    // validate if there's an active filter
    let _filter_result=getlistOfStationFiltered(filterGlobal,filterGlobal.startDate,filterGlobal.endDate)
    _filter_result=_filter_result.toString()  
    let statinlist=_filter_result
    
    if (midIntFiltersIsHidden && filterGlobal.startDate === '' && filterGlobal.endDate === ''){
      query.where = "station_type = 2 and is_shared = 0 and visible = 1 "
    }
    else if(_filter_result!="nofilter" && _filter_result!==""){
      query.where = "station_id IN ("+_filter_result+") "
    }else{
      query.where = "station_id > 0 "
    }  
    
    if (storageFileIds !== null) {
      if (storageFileIds.length === 0) {
        query.where = query.where + ` AND station_id IN (-1) `;
      } else {
        query.where = query.where + ` AND station_id IN (${storageFileIds.join(',')}) `;
      }
    }

    if((searchParam && searchParam !== "") || (_searchTxt && _searchTxt !== "")) {
      let tmpSearchTxt = searchParam ? (searchParam !== _searchTxt) ? _searchTxt : searchParam : _searchTxt;
      if(tmpSearchTxt.includes("(") && tmpSearchTxt.includes(")")) {
        const tmpStart = tmpSearchTxt.indexOf("(")+1;
        const tmpEnd = tmpSearchTxt.indexOf(")");
        const newSearchTxt = tmpSearchTxt.substring(tmpStart,tmpEnd);
        let tmpquery = " lower(client_station_id) like '%"+(newSearchTxt.toLocaleLowerCase())+"%'";
        query.where = query.where ? query.where + ` AND ${tmpquery} ` : tmpquery;
      } else {
        var attrs = [
          'agency',
          'all_approach',
          'bicycleyear',
          'classyear',
          'client_station_id',
          'community',
          'description',
          'display_name',
          'eb_approach',
          'filter_bicycleyear',
          'filter_classyear',
          'filter_pedestrianyear',
          'filter_speedyear',
          'filter_turningyear',
          'filter_volumeyear',
          'fips_county_code',
          'functional_classification_code',
          'growth_factor_group',
          'is_shared',
          'jurisdiction',
          'miscellaneous',
          'latitude',
          'longitude',
          'nb_approach',
          'neb_approach',
          'nwb_approach',
          'pedestrianyear',
          'posted_route_signing',
          'posted_signed_route_number',
          'primary_purpose',
          'sb_approach',
          'seasonal_factor_group',
          'seb_approach',
          'speed_limit',
          'speedyear',
          'state_code',
          'station_id',
          'station_location',
          'station_privacy',
          'station_type',
          'stationtype',
          'status',
          'swb_approach',
          'turningyear',
          'visible',
          'volumeyear',
          'wb_approach',
          'year_station_established',
          'lane_config_control_type' 
        ] 
        tmpSearchTxt = tmpSearchTxt.toLowerCase().trim();
        let tmpquery = " (";
        attrs.map((attr)=>tmpquery===" ("?tmpquery+="lower("+attr+") like '%"+(tmpSearchTxt)+"%'":tmpquery+="OR lower("+attr+") like '%"+(tmpSearchTxt)+"%'")
        tmpquery+=")"
        query.where = query.where ? query.where + ` AND ${tmpquery} ` : tmpquery;
      }
    }

    return query;
  }

  function selectFeatures(geometry, view) {

    if(polygonLayer){
      // remove polygon layer from map
      map.remove(polygonLayer);
      polygonLayer = null;
    }
    
    let query = gettingQueryWhere();

    view.graphics.removeAll();

    // filter to highlight the features within the geometry
    let featureFilter = {
      geometry
    };

    if (geojsonLayer) {
      // this is important for getting the geometry attribute in each result item
      query.returnGeometry = true;
      // create a query based on the filter if it exists
      geojsonLayer
      .queryFeatures(query)
      .then(function (results) {
        // this are the results for the new polygon layer
        let graphics = results.features;
        if (graphics.length > 0) {
          // zoom to the extent of the polygon with factor 2
          // if(extent) {
            // polygonExtent = geometry.extent.expand(2);
            // extentToPolygon();
          // }
          sp = false;
          loadModules(["esri/layers/FeatureLayer", "esri/Graphic"], { css: true })
          .then(([ FeatureLayer, Graphic]) => {
            let newArr = [];
            // getting attributes for the items in the new polygon layer
            for (let i = 0; i < graphics.length; i++) {
                let tmpGraphic = new Graphic({
                  geometry: graphics[i].geometry,
                  attributes: graphics[i].attributes
                })
                newArr.push(tmpGraphic);
            }
            // getting station fields (this should match with the geojsonlayer fields)
            let fields = gettingStationFields();
            // new polygon layer
            polygonLayer = new FeatureLayer({
              geometryType: "point",
              source: newArr,
              fields,
              outFields : ["station_id", "client_station_id", "station_location", "station_type", "latitude", "longitude","display_name","is_shared","visible","turningyear", "pedestrianyear", "bicycleyear","volumeyear", "classyear", "speedyear","haslane","capacityam","capacitymid","capacitypm", "lane_config_control_type"],
              renderer: getMarkerBasedOnType()
            })
            // hide geojsonlayer
            geojsonLayer.visible = false;
            // adding polygon layer to map
            map.add(polygonLayer);
            view.whenLayerView(polygonLayer).then((layerView) => {
                // execute the filter based on the geometry (polygon draw) and exclude the rest of the stations
                layerView.effect = {
                  filter: featureFilter,
                  excludedEffect: "opacity(50%)"
                };

                // new query based on geometry for getting the stations for the results rail
                const queryTmp = layerView.createQuery();
                queryTmp.geometry = geometry;
                polygonLayer.queryFeatures(queryTmp)
                .then(function (resultsPol) {
                  let items = resultsPol.features;
                  let searchDataArr = [];
                  // creating new array that be sent to the results panel
                  for (let i = 0; i < items.length; i++) {
                    if(!isLogin()){
                      if(items[i].attributes.is_shared) {
                        items[i].attributes.visible = 0;
                      }
                    }
                    searchDataArr.push({
                      station_id: items[i].attributes.station_id,
                      client_station_id: items[i].attributes.client_station_id,
                      station_location: items[i].attributes.station_location,
                      station_type: items[i].attributes.station_type,
                      latitude: items[i].attributes.latitude,
                      longitude: items[i].attributes.longitude,
                      visible: items[i].attributes.visible,
                      agency: items[i].attributes.agency,
                      key_value: items[i].attributes.key_value,
                      is_shared: items[i].attributes.is_shared,
                      turningyear: items[i].attributes.turningyear,
                      pedestrianyear: items[i].attributes.pedestrianyear,
                      bicycleyear: items[i].attributes.bicycleyear,
                      volumeyear: items[i].attributes.volumeyear,
                      classyear: items[i].attributes.classyear,
                      speedyear: items[i].attributes.speedyear,
                      filter_turningyear: items[i].attributes.filter_turningyear,
                      filter_pedestrianyear: items[i].attributes.filter_pedestrianyear,
                      filter_bicycleyear: items[i].attributes.filter_bicycleyear,
                      filter_volumeyear: items[i].attributes.filter_volumeyear,
                      filter_classyear: items[i].attributes.filter_classyear,
                      filter_speedyear: items[i].attributes.filter_speedyear,
                      capacityassessment: items[i].attributes.capacityassessment,
                      haslane: items[i].attributes.haslane,
                      globalperiod: items[i].attributes.globalperiod,
                      capacityam: items[i].attributes.capacityam,
                      capacitymid: items[i].attributes.capacitymid,
                      capacitypm: items[i].attributes.capacitypm,
                      display_name: items[i].attributes.display_name,
                      all_approach: items[i].attributes.all_approach,
                      lane_config_control_type: items[i].attributes.lane_config_control_type
                    })
                  }
                  searchDataArr = [...new Map(searchDataArr.map(item => [item.station_id, item])).values()];
                  previousResultForPolygon = searchDataArr;
                  setShowSearchWidgetResult(true)
                  setSearchResult(searchDataArr);
                  setSearchResultv2([]);
                  searchedList = searchDataArr;
                  setSearchChecked(true);
                  setMutipleStationId([]);

                  // set cookie for polygon selection before sign in
                  if(!Cookies.get('payload')) {
                    clearCookie('activeSearchFilter');
                    clearCookie('activeSearchStation');
                    setCookie('activeSearchText', 'polygon');
                    sessionStorage.setItem('activeSearchResult', JSON.stringify(searchDataArr));
                    let obj = {
                      xmax: geometry.extent.xmax,
                      xmin: geometry.extent.xmin,
                      ymax: geometry.extent.ymax,
                      ymin: geometry.extent.ymin,
                      spatialReference: {
                        wkid: geometry.extent.spatialReference.wkid,
                        latestWkid: geometry.extent.spatialReference.latestWkid
                      }
                    }
                    setCookie('polygonExtent', JSON.stringify(obj));
                  }
                });
            });
          })
          .catch(function (error) {
            console.log("error : ", error)
          })
        }
      })
      .catch();
    }

    let cc = 0;
    let vis = 0;
    let tmpToExport = [];
    cLayers.forEach(function(clayer){
      if(clayer.visible && clayer.layerName !== "Stations") {
        const queryExtLayer = {
          geometry: geometry,
          outFields:["*"]
        };
        vis++;
        let layerObj = clayer.layerObj;
        // query.geometry = view.extent;
        queryExtLayer.returnGeometry = true;
        queryExtLayer.outSpatialReference = {"wkid" : 4326}
        layerObj.queryFeatures(queryExtLayer)
        .then(function(cres){
          cc++;
          let tmp = [];
          cres.features.forEach(function(it){
            if(clayer.layerType === "point"){
                if(it.geometry.latitude)
                  tmp.push({attributes: it.attributes, geometry: [it.geometry.longitude, it.geometry.latitude]});
                else 
                  tmp.push({attributes: it.attributes, geometry: [it.geometry.x, it.geometry.y]});
            } else if(clayer.layerType === "polygon"){
              if(it.geometry.rings)
                tmp.push({attributes: it.attributes, geometry: it.geometry.rings});
            } else if(clayer.layerType === "polyline"){
              if(it.geometry.paths)
                tmp.push({attributes: it.attributes, geometry: it.geometry.paths[0]});
            }
          });
          if(cres.features.length > 0)
            tmpToExport.push({layerName: clayer.layerName, layerType: clayer.layerType, layerIcon: clayer.icon, features: tmp});
          if(cc === vis) {
            let sortedLayers = [];
            cLayers.forEach(function(clayer){
              let clayerName = clayer.layerName;
              let filterRes = tmpToExport.filter((layer) => clayerName === layer.layerName);
              if(filterRes.length > 0){
                sortedLayers.push(filterRes[0])
              }
            });
            setExternalLayersToExport(sortedLayers);
          }
        });
      }
    })
    // effect to exclude the features from external layers
    cLayers.forEach(function(ly){
      if(ly.visible && ly.layerName !== "Stations") {
        let obj = ly.layerObj;
        view.whenLayerView(obj).then((lV) => {
          if(lV.layer.layer_type_a === "external"){
            featurExternalLayerView.push(lV);
            lV.effect = {
              filter: featureFilter,
              excludedEffect: "opacity(50%)"
            };
          }
        });
      }
    })
  }

  const gettingStationFields = () => {
    let fields = [
      {
        name: "station_id",
        alias: "station_id",
        type: "oid"
      }, {
        name: "client_station_id",
        alias: "client_station_id",
        type: "string"
      }, {
        name: "station_location",
        alias: "station_location",
        type: "string"
      },
      {
        name: "station_type",
        alias: "station_type",
        type: "integer"
      },
      {
        name: "latitude",
        alias: "latitude",
        type: "double"
      },
      {
        name: "longitude",
        alias: "longitude",
        type: "double"
      },
      {
        name: "visible",
        alias: "visible",
        type: "integer"
      },
      {
        name: "agency",
        alias: "agency",
        type: "string"
      },
      {
        name: "is_shared",
        alias: "is_shared",
        type: "integer"
      },
      {
        name: "turningyear",
        alias: "turningyear",
        type: "string"
      },
      {
        name: "pedestrianyear",
        alias: "pedestrianyear",
        type: "string"
      },
      {
        name: "bicycleyear",
        alias: "bicycleyear",
        type: "string"
      },
      {
        name: "volumeyear",
        alias: "volumeyear",
        type: "string"
      },
      {
        name: "classyear",
        alias: "classyear",
        type: "string"
      },
      {
        name: "speedyear",
        alias: "speedyear",
        type: "string"
      },
      {
        name: "filter_turningyear",
        alias: "filter_turningyear",
        type: "string"
      },
      {
        name: "filter_pedestrianyear",
        alias: "filter_pedestrianyear",
        type: "string"
      },
      {
        name: "filter_bicycleyear",
        alias: "filter_bicycleyear",
        type: "string"
      },
      {
        name: "filter_volumeyear",
        alias: "filter_volumeyear",
        type: "string"
      },
      {
        name: "filter_classyear",
        alias: "filter_classyear",
        type: "string"
      },
      {
        name: "filter_speedyear",
        alias: "filter_speedyear",
        type: "string"
      },
      {
        name: "haslane",
        alias: "haslane",
        type: "integer"
      },
      {
        name: "capacityassessment",
        alias: "capacityassessment",
        type: "string"
      },
      {
        name: "globalperiod",
        alias: "globalperiod",
        type: "string"
      },
      {
        name: "capacityam",
        alias: "capacityam",
        type: "integer"
      },
      {
        name: "capacitymid",
        alias: "capacitymid",
        type: "integer"
      },
      {
        name: "capacitypm",
        alias: "capacitypm",
        type: "integer"
      },
      {
        name: "display_name",
        alias: "display_name",
        type: "string"
      },
      {
        name: "all_approach",
        alias: "all_approach",
        type: "string"
      },
      {
        name: "lane_config_control_type",
        alias: "lane_config_control_type",
        type: "string"
      }
    ];
    return fields;
  }

  const getMarkerBasedOnType = (val=null) => {
    let isActive = val ? val : toggleScenariosTmp;
    let markersRenderer;
    if(isActive) {
      const grayMidSym = {
        type: "picture-marker",  // autocasts as new PictureMarkerSymbol()
        url: require("../../assets/icons/map_pin_mb_gray.svg"),
        width: "40px",
        height: "40px",
        yoffset: "20px"
      };
      const grayIntSym = {
        type: "picture-marker",  // autocasts as new PictureMarkerSymbol()
        url: require("../../assets/icons/map_pin_int_gray.svg"),
        width: "40px",
        height: "40px",
        yoffset: "20px"
      };
      const redSym = {
        type: "picture-marker",  // autocasts as new PictureMarkerSymbol()
        url: require("../../assets/icons/map_pin_int_over.svg"),
        width: "40px",
        height: "40px",
        yoffset: "20px"
      };
      const greenSym = {
        type: "picture-marker",  // autocasts as new PictureMarkerSymbol()
        url: require("../../assets/icons/map_pin_int_under.svg"),
        width: "40px",
        height: "40px",
        yoffset: "20px"
      };
      const yellowSym = {
        type: "picture-marker",  // autocasts as new PictureMarkerSymbol()
        url: require("../../assets/icons/map_pin_int_near.svg"),
        width: "40px",
        height: "40px",
        yoffset: "20px"
      };
      const notSetIntSym = {
        type: "picture-marker",  // autocasts as new PictureMarkerSymbol()
        url: require("../../assets/icons/not_set_2.svg"),
        width: "40px",
        height: "40px",
        yoffset: "20px"
      };
      const SetIntSym = {
        type: "picture-marker",  // autocasts as new PictureMarkerSymbol()
        url: require("../../assets/icons/map_pin_int_2.svg"),
        width: "40px",
        height: "40px",
        yoffset: "20px"
      };
      const underCapacity = {
        type: "picture-marker",  // autocasts as new PictureMarkerSymbol()
        url: require("../../assets/icons/under_capacity_normal.svg"),
        width: "40px",
        height: "40px",
        yoffset: "20px"
      };
      const nearCapacity = {
        type: "picture-marker",  // autocasts as new PictureMarkerSymbol()
        url: require("../../assets/icons/near_capacity_normal.svg"),
        width: "40px",
        height: "40px",
        yoffset: "20px"
      };
      const overCapacity = {
        type: "picture-marker",  // autocasts as new PictureMarkerSymbol()
        url: require("../../assets/icons/over_capacity_normal.svg"),
        width: "40px",
        height: "40px",
        yoffset: "20px"
      };     
      // let tmpRen = geojsonLayer.renderer.clone();
      if (iconMarkerBasedOnLaneGeometryLayer){
        markersRenderer = {
          type: "unique-value",  // autocasts as new SimpleRenderer()
          field: "station_type",
          field2: "is_shared",
          field3: "haslane",  
          fieldDelimiter: ", ",          
          defaultSymbol: notSetIntSym,              
          uniqueValueInfos:[{
            value: "1, 0, 0",                
            symbol: hiddenSym
          },{
            value: "1, 1, 0",                
            symbol: hiddenSym
          },{
            value: "2, 1, 0",                
            symbol: hiddenSym
          },{
            value: "2, 1, 1",                
            symbol: hiddenSym
          },{
            value: "2, 0, 0",                
            symbol: notSetIntSym
          },{
            value: "2, 0, 1",                
            symbol: SetIntSym
          },
        ]
        };
      } else if (iconMarkerBasedOnCapacityLayer) {
        const station_type = "$feature.station_type";
        const is_shared = "$feature.is_shared";
        const visible = "$feature.visible";
        const capacityam = "$feature.capacityam";
        const capacitymid = "$feature.capacitymid";
        const capacitypm = "$feature.capacitypm";
        let vE = null;
        if (iconMarkerCapacitySelected === "AM") {
          vE = `IIf(${station_type} == 2, IIf(${is_shared} == 0, IIf(${visible} == 1, Decode(${capacityam}, 1, 'under', 2, 'near', 3, 'over', 1), 0), 0), 0)`;
        } else if (iconMarkerCapacitySelected === "MID") {
          vE = `IIf(${station_type} == 2, IIf(${is_shared} == 0, IIf(${visible} == 1, Decode(${capacitymid}, 1, 'under', 2, 'near', 3, 'over', 1), 0), 0), 0)`;
        } else if (iconMarkerCapacitySelected === "PM") {
          vE = `IIf(${station_type} == 2, IIf(${is_shared} == 0, IIf(${visible} == 1, Decode(${capacitypm}, 1, 'under', 2, 'near', 3, 'over', 1), 0), 0), 0)`;
        }
        markersRenderer = {
          type: "unique-value",
          valueExpression: vE,
          uniqueValueInfos: [{
            value: "0",
            symbol: hiddenSym
          }, {
            value: "1",
            symbol: notSetIntSym
          }, {
            value: "under",
            symbol: underCapacity
          }, {
            value: "near",
            symbol: nearCapacity
          }, {
            value: "over",
            symbol: overCapacity
          }
          ]
        };
      } else
      markersRenderer = {
        type: "unique-value",  // autocasts as new SimpleRenderer()
        field: "capacityassessment",
        field2: "station_type",
        field3: "is_shared",  
        fieldDelimiter: ", ",          
        defaultSymbol: grayIntSym,              
        uniqueValueInfos:[{
          value: "0, 1, 1",                
          symbol: hiddenSym
        },{
          value: "0, 1, 0",                
          symbol: grayMidSym
        },{
          value: "0, 2, 1",                
          symbol: hiddenSym
        },{
          value: "0, 2, 0",                
          symbol: grayIntSym
        },{
          value: "1, 2, 1",                
          symbol: hiddenSym
        },{
          value: "1, 2, 0",                
          symbol: greenSym
        },{
          value: "2, 2, 1",                
          symbol: hiddenSym
        },{
          value: "2, 2, 0",                
          symbol: yellowSym
        },{
          value: "3, 2, 1",                
          symbol: hiddenSym
        },{
          value: "3, 2, 0",                
          symbol: redSym
        }
      ]
      };
    } else {
      if (Object.values(filterGlobal.intersection_type).filter(item => item === true).length > 0) {
        const station_type = "$feature.station_type";
        const is_shared = "$feature.is_shared";
        const visible = "$feature.visible";
        const int_control_type = "$feature.lane_config_control_type";

        let vE = `
        return IIF(
          ${visible} == 0, 
          0
          , 
          IIF(${is_shared} == 1, 
            When(
              ${station_type} == 1, 'mid_shared',
              ${station_type} == 2, 'int_shared',
              0)
            , 
            IIF(
              ${station_type} == 1, 'mid',
              When(
                ${int_control_type} == 'signal', 'signal',
                ${int_control_type} == 'stop', 'stop',
                ${int_control_type} == 'roundabout', 'roundabout',
                'unknown'
              )            
            )
          )        
        );`;

        markersRenderer = {
          type: "unique-value",
          valueExpression: vE,
          uniqueValueInfos: [{
            value: "0",
            symbol: hiddenSym
          }, {
            value: "mid_shared",
            symbol: isLogin() ? symbolInt_shared : hiddenSym
          }, {
            value: "int_shared",
            symbol: isLogin() ? symbolInt_shared : hiddenSym
          }, {
            value: "mid",
            symbol: symbolMid
          }, {
            value: "signal",
            symbol: intSignalSym
          }, {
            value: "stop",
            symbol: intStopSym
          }, {
            value: "roundabout",
            symbol: intRoundaboutSym
          }, {
            value: "unknown",
            symbol: intunknownSym
          }]
        };

      } else {
        markersRenderer = getDefaultRender();
      }      
    }
    if(val !== null) {
      if(polygonLayer) {
        polygonLayer.renderer = markersRenderer;
      } 
      geojsonLayer.renderer = markersRenderer;  
    }

    return markersRenderer;
  }

  const setMarkerBasedOnLaneGeometryLayer = (val=null) => {
    let isActive = val ? val : toggleScenariosTmp;
    let markersRenderer;
    setToggleMarkerBasedOnCapacityLayer(false);
    iconMarkerBasedOnCapacityLayer=false;
    setToggleMarkerBasedOnLaneGeometryLayer(true);    
    iconMarkerBasedOnLaneGeometryLayer=true;
    if(isActive) {
      const notSetIntSym = {
        type: "picture-marker",  // autocasts as new PictureMarkerSymbol()
        url: require("../../assets/icons/not_set_2.svg"),
        width: "40px",
        height: "40px",
        yoffset: "20px"
      };
      const SetIntSym = {
        type: "picture-marker",  // autocasts as new PictureMarkerSymbol()
        url: require("../../assets/icons/map_pin_int_2.svg"),
        width: "40px",
        height: "40px",
        yoffset: "20px"
      };
      // let tmpRen = geojsonLayer.renderer.clone();
      markersRenderer = {
        type: "unique-value",  // autocasts as new SimpleRenderer()
        field: "station_type",
        field2: "is_shared",
        field3: "haslane",  
        fieldDelimiter: ", ",          
        defaultSymbol: notSetIntSym,              
        uniqueValueInfos:[{
          value: "1, 0, 0",                
          symbol: hiddenSym
        },{
          value: "1, 1, 0",                
          symbol: hiddenSym
        },{
          value: "2, 1, 0",                
          symbol: hiddenSym
        },{
          value: "2, 1, 1",                
          symbol: hiddenSym
        },{
          value: "2, 0, 0",                
          symbol: notSetIntSym
        },{
          value: "2, 0, 1",                
          symbol: SetIntSym
        },
      ]
      };
    } else {
      markersRenderer = getDefaultRender();
    }
    if(val !== null) {
      if(polygonLayer) {
        polygonLayer.renderer = markersRenderer;
      } 
      geojsonLayer.renderer = markersRenderer;  
    }
  }

  const setMarkerBasedOnDefaultLayer = (val=null) => {
    let isActive = val ? val : toggleScenariosTmp;
    let markersRenderer;
    setToggleMarkerBasedOnLaneGeometryLayer(false);
    iconMarkerBasedOnLaneGeometryLayer=false;
    setToggleMarkerBasedOnCapacityLayer(false);
    iconMarkerBasedOnCapacityLayer=false;
    iconMarkerCapacitySelected='';
    if(isActive) {
      markersRenderer = getDefaultRender();      
    }
    if(val !== null) {
      if(polygonLayer) {
        polygonLayer.renderer = markersRenderer;
      } 
      geojsonLayer.renderer = markersRenderer;  
    }
  }

  const setMarkerBasedOnCapacityLayer = (val=null, period) => {
    period = period.toUpperCase();
    let isActive = val ? val : toggleScenariosTmp;
    let markersRenderer;
    setToggleMarkerBasedOnLaneGeometryLayer(false);
    iconMarkerBasedOnLaneGeometryLayer=false;
    setToggleMarkerBasedOnCapacityLayer(true);
    iconMarkerBasedOnCapacityLayer=true;
    setToggleMarkerCapacitySelected(period);
    iconMarkerCapacitySelected=period;
    if(isActive) {
      const notSetIntSym = {
        type: "picture-marker",  // autocasts as new PictureMarkerSymbol()
        url: require("../../assets/icons/not_set_2.svg"),
        width: "40px",
        height: "40px",
        yoffset: "20px"
      };
      const underCapacity = {
        type: "picture-marker",  // autocasts as new PictureMarkerSymbol()
        url: require("../../assets/icons/under_capacity_normal.svg"),
        width: "40px",
        height: "40px",
        yoffset: "20px"
      };
      const nearCapacity = {
        type: "picture-marker",  // autocasts as new PictureMarkerSymbol()
        url: require("../../assets/icons/near_capacity_normal.svg"),
        width: "40px",
        height: "40px",
        yoffset: "20px"
      };
      const overCapacity = {
        type: "picture-marker",  // autocasts as new PictureMarkerSymbol()
        url: require("../../assets/icons/over_capacity_normal.svg"),
        width: "40px",
        height: "40px",
        yoffset: "20px"
      };
      // let tmpRen = geojsonLayer.renderer.clone();
      const station_type = "$feature.station_type";
      const is_shared = "$feature.is_shared";
      const visible = "$feature.visible";
      const capacityam = "$feature.capacityam";
      const capacitymid = "$feature.capacitymid";
      const capacitypm = "$feature.capacitypm";
      
      let vE = null;
      if(period === "AM"){
        vE = `IIf(${station_type} == 2, IIf(${is_shared} == 0, IIf(${visible} == 1, Decode(${capacityam}, 1, 'under', 2, 'near', 3, 'over', 1), 0), 0), 0)`;
      } else if(period === "MID") {
        vE = `IIf(${station_type} == 2, IIf(${is_shared} == 0, IIf(${visible} == 1, Decode(${capacitymid}, 1, 'under', 2, 'near', 3, 'over', 1), 0), 0), 0)`;
      } else {
        vE = `IIf(${station_type} == 2, IIf(${is_shared} == 0, IIf(${visible} == 1, Decode(${capacitypm}, 1, 'under', 2, 'near', 3, 'over', 1), 0), 0), 0)`;
      }
      markersRenderer = {
        type: "unique-value",
        valueExpression: vE,
        //valueExpression:`IIf(${station_type} == 2, IIf(${is_shared} == 0, Decode(${capacityassessment}, 1, 'under', 2, 'near', 3, 'over', 1), 0), 0)`,
        //valueExpression:`IIf(${station_type} == 2, IIf(${is_shared} == 0, IIf(${countscenarios} > 0, Decode(${globalperiod}, 'AM', Decode(${capacityassessment}, 1, 'under', 2, 'near', 3, 'over', 1), 'MID', Decode(${capacityassessment}, 1, 'under', 2, 'near', 3, 'over', 1), 'PM', Decode(${capacityassessment}, 1, 'under', 2, 'near', 3, 'over', 1), 1), 0), 0), 0)`,
        //valueExpression:`When(${station_type} == 2 && ${is_shared} == 0 && ${globalperiod} == 'AM', 1, 0)`,
        uniqueValueInfos:[{
          value: "0",                
          symbol: hiddenSym
        },{
          value: "1",                
          symbol: notSetIntSym
        },{
          value: "under",                
          symbol: underCapacity
        },{
          value: "near",                
          symbol: nearCapacity
        },{
          value: "over",                
          symbol: overCapacity
        }
      ]
      };
    } else {
      markersRenderer = getDefaultRender();
    }
    if(val !== null) {
      if(polygonLayer) {
        polygonLayer.renderer = markersRenderer;
      } 
      geojsonLayer.renderer = markersRenderer;  
    }
  }

  const getDefaultRender = () => {
    let markersRenderer = {
      type: "unique-value",  // autocasts as new SimpleRenderer()
      field: "station_type", 
      field2: "is_shared",
      field3: "visible",   
      fieldDelimiter: ", ",          
      defaultSymbol: otherSym,              
      uniqueValueInfos:[{
        value: "2, 0, 1",                
        symbol: symbolInt
      },{
        value: "1, 0, 1",                
        symbol: symbolMid
      },{
        value: "2, 1, 1",                
        symbol: isLogin()?symbolInt_shared : hiddenSym
      },{
        value: "1, 1, 1",                
        symbol: isLogin()? symbolMid_shared : hiddenSym
      },{
        value: "2, 1, 0",                
        symbol: hiddenSym
      },{
        value: "1, 1, 0",                
        symbol: hiddenSym
      }]
    };  

    return markersRenderer;
  }

  const setDefaultRender = ()=>{
    if (geojsonLayer){
      let markersRenderer = getDefaultRender();
      if(polygonLayer) {
        polygonLayer.renderer = markersRenderer;
      } 
      geojsonLayer.renderer = markersRenderer; 
    }    
  }

  const changeDefaultRender = () => {
    if (Object.values(filter.intersection_type).filter(item => item === true).length > 0) {

      const station_type = "$feature.station_type";
      const is_shared = "$feature.is_shared";
      const visible = "$feature.visible";
      const int_control_type = "$feature.lane_config_control_type";

      let vE = `
      return IIF(
        ${visible} == 0, 
        0
        , 
        IIF(${is_shared} == 1, 
          When(
            ${station_type} == 1, 'mid_shared',
            ${station_type} == 2, 'int_shared',
            0)
          , 
          IIF(
            ${station_type} == 1, 'mid',
            When(
              ${int_control_type} == 'signal', 'signal',
              ${int_control_type} == 'stop', 'stop',
              ${int_control_type} == 'roundabout', 'roundabout',
              'unknown'
            )            
          )
        )        
      );`;

      let markersRenderer = {
        type: "unique-value",
        valueExpression: vE,
        uniqueValueInfos: [{
          value: "0",
          symbol: hiddenSym
        }, {
          value: "mid_shared",
          symbol: isLogin() ? symbolInt_shared : hiddenSym
        }, {
          value: "int_shared",
          symbol: isLogin() ? symbolInt_shared : hiddenSym
        }, {
          value: "mid",
          symbol: symbolMid
        }, {
          value: "signal",
          symbol: intSignalSym
        },{
          value: "stop",
          symbol: intStopSym
        }, {
          value: "roundabout",
          symbol: intRoundaboutSym
        }, {
          value: "unknown",
          symbol: intunknownSym
        }]
      };

      if(polygonLayer) {
        polygonLayer.renderer = markersRenderer;
      } 
      geojsonLayer.renderer = markersRenderer; 

    }
  }

  const extentToPolygon = () => {
    view.extent = polygonExtent;
  }

  const handleActiveImportFile = (val) => {
    activeImportFiles = val;
  }

  const handleActiveExportFiles = (val) => {
    activeExportFiles = val;
  }

  const handleActiveLocationSel = (uniqueid) => {
    stationLocationSelection = uniqueid;
  }

  const handleClearExport = () => {
    setSearchResultv2(previousResult);
  }

  const handleStationDetails = (station_id, station_type) => {
    sessionStorage.setItem('viewStationId', station_id);
    setShowStationDetails(true);
  }
  const updateList=(value)=>{
    setNeedToReload(value)
  }

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const handleToggleScenariosLayer = (val) => {
    toggleScenariosTmp = val;
    setToggleScenariosLayer(val);
    getMarkerBasedOnType(val);

    filterStations();
  }

  const handleToggleLaneGeometryLayer = (val) => {
    /* console.log("val", val);
    console.log("polygonLayer", polygonLayer);
    console.log("geojsonLayer", geojsonLayer); */
    toggleScenariosTmp = val;
    setHiddenMidAndIntFilters(val);
    setToggleScenariosLayer(val);
    setMarkerBasedOnLaneGeometryLayer(val);
    // filterNoSharedStations();
    //filterStations("justintersections");
    /* updateFilterisactive(true);
    updateMainFilter('bicycle',val); */
  }

  const handleToggleDefaultLayer = (val) => {
    toggleScenariosTmp = !val;
    setHiddenMidAndIntFilters(!val);
    setToggleScenariosLayer(val);
    setMarkerBasedOnDefaultLayer(val);
    // filterNoSharedStations();
    //filterStations();
  }

  const handleToggleCapacityLayer = (val, period) => {
    toggleScenariosTmp = val;
    setHiddenMidAndIntFilters(val);
    setToggleScenariosLayer(val);
    setMarkerBasedOnCapacityLayer(val, period);
    /*filterNoSharedStations(); */
    //filterStations("justintersections");
  }

  const filterStations = (filtertype, period=null) => {
    period = period ? period.toUpperCase() : null;
    let val = toggleScenariosTmp;
    try {
      let query = {};
      if(filterToggle) {
        // validate if there's an active filter
        let _filter_result=getlistOfStationFiltered(filterGlobal,filterGlobal.startDate,filterGlobal.endDate)
        _filter_result=_filter_result.toString()  
        let statinlist=_filter_result
        
        if(statinlist!="nofilter"){
          query.where = val ? "station_id IN ("+statinlist+") and is_shared = 0 and visible = 1 " : "station_id IN ("+statinlist+") "
        }else{
          query.where = val ? "station_id > 0 and is_shared = 0 and visible = 1 " : "station_id > 0 "
        }
      } else {
        if(val) {
          if(filtertype === "justintersections") {
            query.where = `station_type = 2 and is_shared = 0 and visible = 1`;
          }
        }
        else{
          query.where = "station_id > 0 ";
        }
      }
      
      if(geojsonLayer){
        geojsonLayer.queryFeatures(query).then(function(results){  
          const {features} = results  
          setSearchResultv2(features)
          setShowSearchWidgetResult(false)
          setSearchChecked(true); 
          if(geojsonLayer){
            geojsonLayer.refresh();      
          }          
        })  
      }
    } catch (error) {
      console.error(error);
    }
  }
   
  function validateNull(value){
    if (value===null){
      return false
    }else if (value===""){
      return false
    }else if (value===undefined){
      return false
    }else{
      return true
    }
   
    
  }
//this method is for
function goToStation(){
  //  
  const urlParams = new URLSearchParams(window.location.search);
  const stationData = urlParams.get('station');  
 
  try {
    axios({
      method: 'post',
      data: {
        "clientStationId": stationData,
        "sharedby":false
      },
      headers: {
        'payload': Cookies.get('payload'),
        'agencyid': sessionStorage.getItem('agency_id')
      },
      url: API_URL + API_PATH.getStationId
    }).then(function (response) {            
      if (response && response.data && response.data.data && response.data.data.length > 0) {
        const stationId = response.data.data[0].station_id;                      
        getStationDetail(stationId,true);
        flag=false
        setPopuptemplateChecked(false);
        if(!Cookies.get('payload')) {
          setCookie('activeSearchStation', stationId);
        }
      } else {
        
      }
    })
  }
  catch (error) {
    // Throw the error
  }
}

  
  const addedNewStation = (station)=>{        
    if(station){
      loadModules(["esri/geometry/Point"], { css: true })
      .then(async ([Point]) => {
        let station_object = {
          //id : station.station_id,
          geometry : new Point({
            x : parseFloat(station.longitude),
            y : parseFloat(station.latitude)
          }),                   
          attributes : {
            agency: station.fips_county_code,
            agency_id: sessionStorage.getItem('agency_id'),
            all_approach: "North South East West",
            annual_factor_group: station.annual_factor_group,
            bicycleyear: "",
            classyear: "",
            client_station_id: station.client_station_id,
            community: station.community,
            description: station.description,
            display_name: station.display_name,
            eb_approach: station.eb_approach,
            filter_bicycleyear: "",
            filter_classyear: "",
            filter_pedestrianyear: "",
            filter_speedyear: "",
            filter_turningyear: "",
            filter_volumeyear: "",
            fips_county_code: station.fips_county_code,
            functional_classification_code: null,
            growth_factor_group: station.growth_factor_group,
            is_shared: 0,
            jurisdiction: station.jurisdiction,
            miscellaneous: station.miscellaneous,
            latitude: parseFloat(station.latitude),
            longitude: parseFloat(station.longitude),
            method_traffic_volume_count: station.method_traffic_volume_count,
            national_highway_system: station.national_highway_system,
            nb_approach: station.nb_approach,
            neb_approach: station.neb_approach,
            nwb_approach: station.nwb_approach,
            pedestrianyear: "",
            posted_route_signing: null,
            posted_signed_route_number: station.posted_signed_route_number,
            primary_purpose: null,
            sb_approach: station.sb_approach,
            seasonal_factor_group: station.seasonal_factor_group,
            seb_approach: station.seb_approach,
            speed_limit: station.speed_limit,
            speedyear: "",
            state_code: station.state_code,
            station_id: station.station_id,
            station_location: station.station_location,
            station_privacy: station.station_privacy,
            station_type: station.station_type,
            stationtype: (station.station_type==2)?"Intersection":"Midblock",
            status: station.status,
            swb_approach: station.swb_approach,
            turningyear: "",
            visible: 1,
            volumeyear: "",
            wb_approach: station.wb_approach,
            year_station_established: station.year_station_established 
          }
        };
        //add new station to geojsonlayer 
        if(geojsonLayer){        
          geojsonLayer.applyEdits( {
            addFeatures: [station_object]
          }).then(function(res){            
            geojsonLayer.refresh();               
            geojsonLayer.queryFeatures({}).then(function(results){                 
              const {features} = results                         
              setSearchResultv2(features)
              setShowSearchWidgetResult(false)
              setSearchChecked(true);                              
            })
          }).catch((error) => {
            console.log("error = ", error);
          });                   
        }
        if(geoLayerData) {
          let tmpData = geoLayerData.features;
          let tmpObj = {
            geometry: station_object.geometry,
            id: station.station_id,
            properties: station_object.attributes,
            type: "Feature"
          }
          tmpData.push(tmpObj);
          setGeoLayerData({
            features: tmpData,
            type: "FeatureCollection"
          });
          let stationIDData = { station_id: station.station_id, stationId: station.client_station_id };
          setStationDetails([...stationDetails, stationIDData]);
        }
      });       
    }    
  }

  const updateFeatureOnSearchResultv2 = (id, items) => {
    for (let i = 0; i < searchResultv2.length; i++) {
      if (searchResultv2[i]["attributes"]["station_id"] === id) {
        const keys = Object.keys(items);
        keys.forEach((key, index) => {
          searchResultv2[i]["attributes"][key] = items[key];
        });
      }
    }
  }

  const editStationDetails = (sta)=>{   
    if(sta){
      try {
        if(geojsonLayer){
          geojsonLayer.queryFeatures({}).then(function(results){          
            results.features.forEach(function(station,index){
              if(station.attributes.station_id == sta.station_id){
                if(sta.miscellaneous) {
                  results.features[index].attributes.miscellaneous = sta.miscellaneous;
                  results.features[index].attributes.haslane = 1;
                  updateFeatureOnSearchResultv2(sta.station_id, {haslane:1});
                }
                if(sta.FK_lane_config_id) {
                  results.features[index].attributes.FK_lane_config_id = sta.FK_lane_config_id;
                  results.features[index].attributes.haslane = 1;
                  updateFeatureOnSearchResultv2(sta.station_id, {haslane:1});
                }
                else{
                  results.features[index].attributes.haslane = 0;
                  results.features[index].attributes.capacityam = null;
                  results.features[index].attributes.capacitymid = null;
                  results.features[index].attributes.capacitypm = null;
                  updateFeatureOnSearchResultv2(sta.station_id, {haslane : 0, capacityam : null, capacitymid : null, capacitypm : null});
                }
                if(sta.capacityassessment) {
                  results.features[index].attributes.capacityassessment = sta.capacityassessment;
                  results.features[index].attributes.activescenario = sta.activescenario;
                }
                if(sta.globalscenarios) {
                  for (let i = 0; i < sta.globalscenarios.length; i++) {
                    if (sta.globalscenarios[i]["station_id"] === sta.station_id){
                      results.features[index].attributes.capacityam = sta.globalscenarios[i]["globalscenarios"][0]["capacityam"];
                      results.features[index].attributes.capacitymid = sta.globalscenarios[i]["globalscenarios"][0]["capacitymid"];
                      results.features[index].attributes.capacitypm = sta.globalscenarios[i]["globalscenarios"][0]["capacitypm"];
                      updateFeatureOnSearchResultv2(sta.station_id, {haslane : 1, capacityam : sta.globalscenarios[i]["globalscenarios"][0]["capacityam"], capacitymid : sta.globalscenarios[i]["globalscenarios"][0]["capacitymid"], capacitypm : sta.globalscenarios[i]["globalscenarios"][0]["capacitypm"]});                      
                    }
                  }
                }
                getStationDetail(sta.station_id);
                // if(intersectionChecked) {
                //   setPanelStationData(results.features[index].attributes);                
                // }
                if(geojsonLayer){
                  geojsonLayer.applyEdits( {
                    updateFeatures: [results.features[index]]
                  }).then();
                }              
              }            
            });
            //const {features} = results                         
            //setSearchResultv2(features)
            //setShowSearchWidgetResult(false)
            //setSearchChecked(true); 
            if(geojsonLayer){
              geojsonLayer.refresh();      
            }          
            /**/
          })  
        }
      } catch (error) {
        console.error(error);
      } 
    }     //
  }

  return <>
    
    {
      showImportTable &&
      <ImportTable 
        setShowImportTable={setShowImportTable}
        details={details}
        setDetails={setDetails}
        mapLocation={mapLocation}
        setMapLocation={setMapLocation}
        changeMapView={changeMapView}
        geojsonLayer={geojsonLayer}
        stationDetails={stationDetails}
        handleOpenDataManager={handleOpenDataManager}
      />
    }

    <ImportPanel 
      checkedImport={checkedImport} 
      importStationId={importStationId}
      details={details}
      setDetails={setDetails}
      setLoaderShow={setLoaderShow}
      setShowimportData={setShowimportData}
      stationDetails={stationDetails}
      setMapLocation={setMapLocation}
      mapLocation={mapLocation}
      fileCountData={fileCountData}
      setMidblockChecked={setMidblockChecked}
      setIntersectionChecked={setIntersectionChecked}
      setSearchChecked={setSearchChecked}
      tempView={tempView}
      changeMapView={changeMapView}
      setImportFilesListChecked={setImportFilesListChecked}
      setPopuptemplateChecked={setPopuptemplateChecked}
      handleActiveImportFile={handleActiveImportFile}
      setDetailsPanel={setDetailsPanel}
    />

  {/* External layers component */}
  <ExternalLayers 
    sidebarWidth={sidebarWidth}
    handleShowLayersContainer={handleShowLayersContainer}
    customLayers={customLayers}
    setCustomLayers={setCustomLayers}
    myCustomLayers={myCustomLayers}
    setMyCustomLayers={setMyCustomLayers}
    handleLayerVisibility={handleLayerVisibility}
    handleAddLayer={handleAddLayer}
    handleSaveLayer={handleSaveLayer}
    addingExternalLayer={addingExternalLayer}
    layerName={layerName}
    setLayerName={setLayerName}
    layerUrl={layerUrl}
    setLayerUrl={setLayerUrl}
    handleReorderLayer={handleReorderLayer}
    showExternalLayers={showExternalLayers}
    clearAllExternalLayers={clearAllExternalLayers}
  />
  <DataPointLayers 
    sidebarWidth={sidebarWidth}
    handleShowDataPointLayersContainer={handleShowDataPointLayersContainer}
    customLayers={customLayers}
    setCustomLayers={setCustomLayers}
    myCustomLayers={myCustomLayers}
    setMyCustomLayers={setMyCustomLayers}
    handleLayerVisibility={handleLayerVisibility}
    handleAddLayer={handleAddLayer}
    handleSaveLayer={handleSaveLayer}
    addingExternalLayer={addingExternalLayer}
    layerName={layerName}
    setLayerName={setLayerName}
    layerUrl={layerUrl}
    setLayerUrl={setLayerUrl}
    handleReorderLayer={handleReorderLayer}
    showDataPointLayers={showDataPointLayers}
    clearAllExternalLayers={clearAllExternalLayers}
    handleToggleLaneGeometryLayer={handleToggleLaneGeometryLayer}
    handleToggleDefaultLayer={handleToggleDefaultLayer}
    handleToggleCapacityLayer={handleToggleCapacityLayer}
    returnMainLIstPanel={returnMainLIstPanel}
  />

  
  <div className="mainMapContainer">
    <div id="basemapToggle"></div>
     <div className="city-name" style={streetViewMode?{color:'white'}:{}}>{sessionStorage.getItem('displayName')}</div>
    <div className={"contenedor"} > 
      <div data-testid="webmapContainer" className="" id="map_block" ref={mapRef} style={{  flexGrow: 1}} />
      <div className="mainMapPanel" style={{  width: "408px" }}>
        
           
           <Collapse timeout={{ appear: 0, enter: 0, exit: 0}} in={popuptemplateChecked} className="homePopBox" >
             {
              
               popuptemplateChecked &&
               <PopupTemplate
                 showExternalLayers={showExternalLayers}
                 showDataPointLayers={showDataPointLayers}
                 sidebarWidth={sidebarWidth}
                 passPopValue={handlePopBlock}
                 
                 title={popupTitle}
                 content={popupContent}
                 midblockChecked={midblockChecked}
                 intersectionChecked={intersectionChecked}
                 searchChecked={searchChecked}
                
               />
             }
           </Collapse>
           <Collapse timeout={{ appear: 0, enter: 0, exit: 0}} in={detailsPanel} className="homePopBox" className={detailsPanel?'main-details-panel':''}>           
             {
               detailsPanel && 
               <div className='main-details-panel-wpp'>
                 <div className={"detail-panel-top"} style={{}}>              
                   <Button variant="text" className="panel-info-back-btn" startIcon={<ArrowBackIosIcon/>} onClick={() => returnMainLIstPanel()}>Back</Button>                   
                 </div>                 
               {(loadingDetails)?<div className='loader-details-progress'>
                  <div className={'loader'}></div>
                </div>:null }  
               {intersectionChecked && <Intersection
                 showExternalLayers={showExternalLayers}
                 showDataPointLayers={showDataPointLayers}
                 sidebarWidth={sidebarWidth}
                 passIntersectionValue={handleIntersection}
                 stationData={panelStationData}
                 searchPanel={searchPanel}
                 searchChecked={searchChecked}
                 checkExportValue={exportpopUpDetails}
                 groupStations={singleIntersectionStations}
                 setStation={singleIntersectionStationId}
                 hasData={hasData}
                 sharedStation={sharedStation}
                 sharedAgencyName={sharedAgencyName}
                 loadingDetails={loadingDetails}
                 data={detailsPanelIntersection}
                 handleStationDetails={handleStationDetails}
                 toggleMarkerCapacitySelected={toggleMarkerCapacitySelected}
                 toggleMarkerBasedOnCapacityLayer={toggleMarkerBasedOnCapacityLayer}
               />}               
               {
               midblockChecked &&
               <MidBlock
                 showExternalLayers={showExternalLayers}
                 showDataPointLayers={showDataPointLayers}
                 sidebarWidth={sidebarWidth}
                 passMidValue={handleMidBlock}
                 stationData={panelStationData}
                 searchPanel={searchPanel}
                 searchChecked={searchChecked}
                 checkExportValue={exportpopUpDetails}
                 groupStations={singleMidblockStations}
                 setStation={singleMidblockStationId}
                 hasData={hasData}
                 sharedStation={sharedStation}
                 sharedAgencyName={sharedAgencyName}
                 loadingDetails={loadingDetails}
                 data={detailsPanelMidblock}
                 handleStationDetails={handleStationDetails}
               />
               }
               </div>
             }          
           </Collapse>  
          
           <Collapse timeout={{ appear: 0, enter: 0, exit: 0}} in={searchChecked} className="homePopBox" >
             {
               searchChecked &&
               <SearchResults
                 showExternalLayers={showExternalLayers}
                 showDataPointLayers={showDataPointLayers}
                 sidebarWidth={sidebarWidth}
                 passMidValue={handleSearchResults}
                 resultData={searchResult}
                 resultDatav2={searchResultv2}
                 showSearchWidgetResult={showSearchWidgetResult}
                 searchParam={searchParam}
                 selectedStation={selectedStation}
                 highlightStation={highlightStation}
                 cardOver={cardOver}
                 cardOut={cardOut}
                 selectedStationType={selectedStationType}
                 getStationDetail={getStationDetail}
                 checkExportValue={exportpopUp}
                 groupStations={multipleStations}
                 setStation={multipleStationId}
                 allStations={allStations}
                 handleActiveExportFiles={handleActiveExportFiles}
                 handleClearExport={handleClearExport}
                 toggleScenariosLayer={toggleScenariosLayer}
                 toggleMarkerBasedOnCapacityLayer={toggleMarkerBasedOnCapacityLayer}
                 toggleMarkerCapacitySelected={toggleMarkerCapacitySelected}
                 toggleMarkerBasedOnLaneGeometryLayer={toggleMarkerBasedOnLaneGeometryLayer}
                 polygonDrawn={polygonDrawn}
               />
             }
           </Collapse>
           <Collapse timeout={{ appear: 0, enter: 0, exit: 0}} in={importFilesListChecked} className="homePopBox" >
             {
               (importFilesListChecked) &&
               <ImportList
                 details={details}
                 passPopValue={handlePopBlock}
                 setDetails={setDetails}
                 importRemoveLocation={importRemoveLocation}
                 mapLocation={mapLocation}
                 setMapLocation={setMapLocation}
                 changeMapView={changeMapView}
                 handleActiveImportFile={handleActiveImportFile}
                 setImportFilesListChecked={setImportFilesListChecked}
                 setShowImportTable={setShowImportTable}
                 geojsonLayer={geojsonLayer}
                 handleActiveLocationSel={handleActiveLocationSel}
                 stationLocationSelection={stationLocationSelection}
                 activeStationIDSel={activeStationIDSel}
                 stationDetails={stationDetails}
                 handleOpenDataManager={handleOpenDataManager}
               />
             }
           </Collapse>
       </div>    
    </div>  
    
   
    <Box display='flex' flexDirection="column" className="homeIconList">
      <DataIconsTooltip title="Home">
        <div data-testid="homeBtn" className="homeIcon">
          <img src={require('../../assets/icons/map/Home.png')} onClick={() => homeEvent()} />
        </div>
      </DataIconsTooltip>
      <DataIconsTooltip title="View my location">
        <div data-testid="locationBtn" className="locationIcon">
          <img src={require('../../assets/icons/map/location.png')} onClick={() => locationEvent()} />
        </div>
      </DataIconsTooltip>
      <DataIconsTooltip title="Zoom in">
        <div data-testid="zoomInBtn" className="zoomIcon" style={{ marginBottom: '-3px' }}>
          <img src={require('../../assets/icons/map/Add.png')} onClick={() => ZoomInEvent()} />
        </div>
      </DataIconsTooltip>
      <DataIconsTooltip title="Zoom out">
        <div data-testid="zoomOutBtn" className="inIcon">
          <img src={require('../../assets/icons/map/Minus.png')} onClick={() => zoomOutEvent()} />
        </div>
      </DataIconsTooltip>
    </Box>
    <DataIconsTooltip title="Polygon tool">
      <div data-testid="polygonSelectionBtn" className={polygonActive ? "activePolygon" : "polygon"} id="select-by-polygon"
         style={isLogin() ? {} : {right:'517px'}}>
          {polygonActive ?
          <img src={require('../../assets/icons/map/polygon-active.png')} /> 
          : <img src={require('../../assets/icons/map/polygon.png')} /> 
          } 
          <label>{polygonActive && 'Remove'}</label>            
      </div>
    </DataIconsTooltip>
    {isLogin() ?<ExportStations polygonActive={polygonActive} setShowExternalLayers={setShowExternalLayers} setShowDataPointLayers={setShowDataPointLayers}/>:null}
    {exportChecked == 'block' ?
      <div className="exportDataPanel" style={{ display: exportChecked }}>
        <ExportData 
          checkExportValue={exportpopUp} 
          groupStations={midblockChecked ? singleMidblockStationId : intersectionChecked ? singleIntersectionStationId : multipleStationId} />
      </div>
      : null}
      {/* Export modal from details */}
      {exportCheckedDetails == 'block' &&
        <div className="exportDataPanelDetails" style={{ display: exportCheckedDetails }}>
          <ExportDataDetails 
            checkExportValue={exportpopUpDetails} 
            groupStations={midblockChecked ? singleMidblockStationId : intersectionChecked ? singleIntersectionStationId : multipleStationId} />
        </div>
      }
      {/*  */}
    {/* External layers button */}
    {
      <DataIconsTooltip title="External layers">
        <button className={activeExtLayers ? "external-layer-btn-active" : "external-layer-btn"} data-testid="externalLayersBtn" onClick={handleShowLayersContainer} >
          {
            activeExtLayers ?
            <img src={require('../../assets/icons/map/layers-active.svg')} />
            :
            <img src={require('../../assets/icons/map/layers.svg')} />
          }
        </button>
      </DataIconsTooltip>
    }
    <DataIconsTooltip title="DataPoint layers">  
      <button className={"data-point-layer-btn"} data-testid="externalLayersBtn" onClick={handleShowDataPointLayersContainer} >
          <img src={require('../../assets/icons/map/data-point-layers.svg')} />
      </button>
    </DataIconsTooltip>
    {/* Export External Layers modal */}
    {
      externalLayersToExport.length > 0 &&
      <ExportExternalLayers 
        externalLayersToExport={externalLayersToExport}
        setExternalLayersToExport={setExternalLayersToExport}
        clearFilterExternalLayers={clearFilterExternalLayers}
        polygonExtent={polygonExtent}
        view={view}
        extentToPolygon={extentToPolygon}
      />
    }
    {
        openDataManagement && 
        <DataManagement  
          setOpenDataManagement={setOpenDataManagement}
        />
      }
  </div>
  {
    showStationDetails &&
      <StationDetails 
        setShowStationDetails={setShowStationDetails}                   
        setNeedToReload={setNeedToReload}
        needToReload={needToReload}
        updateList={updateList}
      />
  }  
  <HelpDisk />    
  {/*<Footer />*/}
  </>
}

export default MapView;
//End MapView component code ...